// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:48:03.017Z
// Property: Brookwood Village (ID: 6767906449167180)
// Collections: 31 amenities, 7 floorplans (live), 30 photos, 77 POIs, 2 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167180",
  "property_external_id": "924378",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/brookwood-village/5Xs42b/",
  "property_apartments_url": "https://www.apartments.com/brookwood-village-oklahoma-city-ok/k66cn39/",
  "property_google_business_url": "https://www.google.com/maps/place/Brookwood+Village/data=!4m2!3m1!1s0x0:0xf69976f6038fc371?sa=X&ved=2ahUKEwim0rzJ7IOTAxWQOkQIHenOA3EQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47564050535",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "brookwood-village",
  "property_name": "Brookwood Village",
  "property_website_url": "https://www.brookwoodvillageapts.com",
  "property_domain": "https://www.brookwoodvillageapts.com",
  "property_address": "9401 S Shartel Ave",
  "property_full_address": "9401 S Shartel Ave, Oklahoma City, OK 73139",
  "property_address_1": "9401 S Shartel Ave",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": "73139",
  "property_address_zip": "73139",
  "property_address_country": "US",
  "property_address_county": "Cleveland County",
  "property_neighborhood_address": "South Oklahoma City",
  "property_address_latitude": "35.3744213",
  "property_address_longitude": "-97.5239606",
  "property_email": "brookwoodvillage@weidner.com",
  "property_phone": "(833) 896-7786",
  "property_call_tracking_phone": "405-759-4916",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Brookwood Village, Oklahoma City’s hidden gem! Choose from thoughtfully designed studio, one, two, and three-bedroom floor plans, paired with exceptional amenities like a refreshing pool, vibrant sports courts, and a serene picnic area by the pond. Your perfect home awaits—schedule a tour today!",
  "property_long_description": "**Discover Your Ideal Home at Brookwood Village in Oklahoma City, OK!**\n\nWelcome to Brookwood Village, where contemporary comfort meets a vibrant lifestyle! Our welcoming apartment community offers a diverse range of floor plans, including studio, one-bedroom, two-bedroom, and three-bedroom options, designed to cater to your unique living needs. Each home features modern finishes such as plank-style flooring, spacious closets, and fully appointed kitchens, ensuring that you find the perfect fit for your style.\n\nAt Brookwood Village, we believe that exceptional amenities elevate your living experience. Enjoy 24-hour access to our fitness center, take a refreshing dip in the pool, or challenge friends to a game on our tennis or basketball courts. Our expansive grounds feature beautiful walking and biking trails, a tranquil pond, and inviting picnic areas complete with grills for those perfect outdoor gatherings. Your furry friends will love the pet play area while you take advantage of planned social activities in our clubhouse, creating lasting connections with your neighbors.\n\nWe pride ourselves on providing exceptional service, with on-site maintenance and a bilingual leasing team ready to assist you. Whether you're looking for cozy townhome designs or practical storage space, Brookwood Village has everything to transform your apartment into a home. \n\nReady to make Brookwood Village your new home? Find your new home today—browse our availability or schedule a tour to visit our community! Your exceptional lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-f216-7067-b592-79eacafa4ed9.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room with stairs leading to a loft and an open kitchen area.",
    "public_id": "019d021c-f216-7067-b592-79eacafa4ed9",
    "storage_key": "property/6767906449167180/019d021c-f216-7067-b592-79eacafa4ed9.webp",
    "width": 1024,
    "height": 683
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "1128",
  "property_year_built": "1970",
  "property_year_renovated": null,
  "property_walk_score": "50",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.25177304964538",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://brookwoodvillageapts.securecafe.com/onlineleasing/brookwood-village/floorplans.aspx",
  "property_resident_portal_url": "https://brookwoodvillageapts.securecafenet.com/residentservices/brookwood-village/userlogin",
  "property_apply_now_url": "https://brookwoodvillageapts.securecafe.com/onlineleasing/brookwood-village/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-6c1a-7267-8317-5ca7968f9f12.webp",
  "property_primary_logo_media": {
    "alt_text": "Brookwood Village Apartment Homes logo",
    "public_id": "019d021d-6c1a-7267-8317-5ca7968f9f12",
    "storage_key": "property/6767906449167180/019d021d-6c1a-7267-8317-5ca7968f9f12.webp",
    "width": 1836,
    "height": 739
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-9dbc-779d-ac29-54fddcf89c6c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Brookwood Village Apartment Homes logo",
    "public_id": "019d021d-9dbc-779d-ac29-54fddcf89c6c",
    "storage_key": "property/6767906449167180/019d021d-9dbc-779d-ac29-54fddcf89c6c.webp",
    "width": 1836,
    "height": 739
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d0220-0243-74ed-a872-4c2b79ed13a7.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Brookwood Village Apartment Homes logo",
    "public_id": "019d0220-0243-74ed-a872-4c2b79ed13a7",
    "storage_key": "property/6767906449167180/019d0220-0243-74ed-a872-4c2b79ed13a7.webp",
    "width": 640,
    "height": 258
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#5F3933",
  "property_secondary_color": "#ECEDD3",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#B79D74",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1200",
  "property_sqft_min": "564",
  "property_sqft_max": "1200",
  "property_price_range": "715 - 2175",
  "property_price_min": "715",
  "property_price_max": "2175",
  "property_available_units": 31,
  "property_facebook_url": "https://www.facebook.com/BrookwoodVillageApartments",
  "property_instagram_url": "https://www.instagram.com/brookwoodvillageapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJte6VEIAUsocRccOPA_Z2mfY",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Brookwood Village",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today!",
  "property_home_amenities_blurb": "Welcome to Brookwood Village in Oklahoma City, where comfort meets convenience! Choose from spacious studio, one, two, or three-bedroom apartments, each designed with your lifestyle in mind. Enjoy amenities like a refreshing pool, vibrant social activities, and serene walking trails, creating an inviting atmosphere for everyone. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Brookwood Village in Oklahoma City, find a sanctuary that suits your lifestyle. Each thoughtfully designed floor plan invites comfort and style, making every space feel like home. Browse our available apartment homes today to discover the ideal setting for your next chapter of living. ",
  "property_home_gallery_blurb": "Welcome to Brookwood Village in Oklahoma City, where comfort meets community. Choose from studio to three-bedroom floor plans, complemented by exceptional amenities like a pool, fitness center, and pet-friendly spaces. Enjoy vibrant social activities and serene walking trails. Picture yourself living here, surrounded by convenience and warmth!",
  "property_home_neighborhood_blurb": "Welcome to Brookwood Village, your serene retreat in Oklahoma City. With a range of thoughtfully designed floor plans from studios to three-bedroom apartments, our community places you minutes from exceptional schools like Sky Ranch Elementary and West Junior High. Discover local gems and enrich your lifestyle today!",
  "property_home_reviews_blurb": "At Brookwood Village in Oklahoma City, our residents rave about the community spirit and modern amenities, noting it's \"a perfect blend of comfort and convenience.\" Join us and experience the warmth that makes our community feel like home. Curious? See what our residents have to say about living here!",
  "property_neighborhood_blurb": "At Brookwood Village in Oklahoma City, families thrive among stellar educational institutions like Sky Ranch Elementary and Westmoore High School. Engage with a community rich in learning and growth, all while enjoying the comfort of our diverse floor plans. Unearth nearby gems that make our neighborhood truly exceptional.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Brookwood Village in Oklahoma City, your lifestyle meets comfort. With thoughtfully designed studios to spacious three-bedroom apartments, enjoy perks like a fitness center, vibrant social activities, and serene walking trails. Relax in our clubhouse or take a dip in the pool—your perfect retreat awaits!",
  "property_applynow_blurb": "At Brookwood Village in Oklahoma City, your perfect home awaits! Choose from spacious studio, one, two, or three-bedroom layouts while enjoying top-notch amenities like a crystal-clear pool, fitness center, and beautiful walking trails. With a pet-friendly environment and vibrant community activities, leasing your new lifestyle is just a click away!",
  "property_contactus_blurb": "At Brookwood Village in Oklahoma City, we offer versatile floor plans tailored to fit your lifestyle—from cozy studios to spacious three-bedroom apartments. Each unique layout is designed for comfort and convenience. Have questions? Our leasing team is ready to assist you—reach out today and let’s find your perfect home!",
  "property_faqs_blurb": "At Brookwood Village in Oklahoma City, our diverse floor plans—including studios to spacious three-bedroom apartments—cater to every lifestyle. Curious about our community? Browse our FAQs page for insights into amenities, policies, and more, ensuring you find the perfect fit for your new home.",
  "property_floorplans_blurb": "At Brookwood Village in Oklahoma City, OK, you'll find thoughtfully designed floor plans tailored to your lifestyle. Whether you're seeking a cozy studio or a spacious three-bedroom, we have the perfect apartment home just for you. Browse our available options today and envision your new beginning!",
  "property_gallery_blurb": "At Brookwood Village in Oklahoma City, picture yourself enjoying a vibrant lifestyle with our diverse floor plans, from cozy studios to spacious three-bedroom townhomes. Immerse in top-notch amenities like a serene pond, state-of-the-art fitness center, and inviting picnic area, all while feeling right at home in our welcoming community.",
  "property_interactivemap_blurb": "At Brookwood Village in Oklahoma City, our vibrant community awaits you! Choose from spacious floor plans, including studios to three-bedroom residences, and enjoy exceptional amenities like a fitness center, pools, and scenic picnic areas. Let our interactive map guide you to your perfect home today!",
  "property_pets_blurb": "At Brookwood Village in Oklahoma City, your furry family members will feel right at home. With no weight limit and a welcoming atmosphere for cats and dogs (breed restrictions apply), our community embraces pet lovers. Tailored amenities and nearby parks make it easy to enjoy life together.",
  "property_referafriend_blurb": "At Brookwood Village in Oklahoma City, we believe great friends make great neighbors! With diverse floor plans, from cozy studios to spacious three-bedroom apartments, there’s a perfect fit for everyone. Share the joy of community living—refer a friend today and enhance your Brookwood Village experience together!",
  "property_residentaccess_blurb": "At Brookwood Village in Oklahoma City, residents enjoy a range of thoughtfully designed floor plans, including studios, one, two, and three-bedroom options. For current residents, access your portal for seamless rent payments, maintenance requests, and more convenience at your fingertips. Embrace effortless living with every online tool you need!",
  "property_reviews_blurb": "At Brookwood Village in Oklahoma City, residents rave about their vibrant community, noting it’s \"a perfect blend of comfort and convenience.\" Join a neighborhood where friendly faces and exceptional amenities make for an extraordinary living experience. See what our residents have to say about living at our community!",
  "property_created_at": "1771536483750",
  "property_scheduletour_blurb": "At Brookwood Village in Oklahoma City, our diverse floor plans—ranging from cozy studios to spacious three-bedroom apartments—cater to every lifestyle. Experience vibrant living with top-notch amenities. Ready to find your perfect home? Schedule a tour today and hear firsthand from our satisfied residents about life in our welcoming community!",
  "property_thankyou_blurb": "Thank you for reaching out to Brookwood Village in Oklahoma City, where comfort meets style! With a range of thoughtfully designed floor plans including studio, one, two, and three-bedroom options, we have the perfect home awaiting you. Our team will connect soon to help you take the next step!",
  "property_virtualtours_blurb": "Step into the enchanting world of Brookwood Village in Oklahoma City, where modern living meets comfort. Our diverse floor plans—studio to three-bedroom—offer a home tailored to your style. Experience it firsthand—take a virtual tour and envision your new lifestyle today!",
  "property_copyright": "2026 All Rights Reserved. Brookwood Village",
  "property_seo_title_home": "Apartments for Rent - Brookwood Village - Oklahoma City, OK",
  "property_seo_description_home": "Enjoy walk-in closets, planned social events, pet perks, and quick access to I-35 and I-240 at Brookwood Village in Oklahoma City, OK.",
  "property_seo_title_floorplans": "Floor Plans - Brookwood Village Apartments - Oklahoma City, OK",
  "property_seo_description_floorplans": "Discover spacious studio, one-, two-, and three-bedroom apartment floor plans with walk-in closets at Brookwood Village in Oklahoma City, OK.",
  "property_seo_title_amenities": "Amenities - Brookwood Village Apartments - Oklahoma City, OK",
  "property_seo_description_amenities": "Enjoy a fitness center, pool, clubhouse, and nature trails plus walk-in closets and more at Brookwood Village Apartments in Oklahoma City, OK.",
  "property_seo_title_gallery": "Photo Gallery - Brookwood Village - Oklahoma City, OK",
  "property_seo_description_gallery": "Discover inviting interiors and lively amenities at Brookwood Village Apartments in Oklahoma City, OK. Picture your lifestyle.",
  "property_seo_title_virtualtours": "Brookwood Village Virtual Tour - Oklahoma City, OK",
  "property_seo_description_virtualtours": "Explore life at Brookwood Village Apartments in Oklahoma City, OK with our convenient virtual tour platform. Picture your new home from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Brookwood Village Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Brookwood Village, OKC! Explore our interactive map for spacious layouts, luxury amenities, and vibrant living.",
  "property_seo_title_neighborhood": "Neighborhood - Brookwood Village - Oklahoma City, OK",
  "property_seo_description_neighborhood": "Discover comfortable apartment living near Walmart and Will Rogers World Airport at Brookwood Village in Oklahoma City, OK.",
  "property_seo_title_contact": "Contact Brookwood Village Apartments - Oklahoma City, OK",
  "property_seo_description_contact": "Connect with the Brookwood Village Apartments team in Oklahoma City, OK. Learn more about available apartment homes today.",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, OK",
  "property_seo_description_faqs": "Have questions about Brookwood Village in Oklahoma City? Browse our FAQs for insights on spacious floor plans, charming amenities, and community life!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, OK",
  "property_seo_description_reviews": "Uncover the charm of Brookwood Village in Oklahoma City! Check out real resident reviews and see why our community is the perfect place to call home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, OK",
  "property_seo_description_applynow": "Welcome home to Brookwood Village in Oklahoma City! Choose from spacious studios to three-bedroom apartments with amazing amenities and a vibrant community.",
  "property_seo_title_residentaccess": "Resident Access | Brookwood Village",
  "property_seo_description_residentaccess": "Log in to your Brookwood Village resident portal for easy rent payments, maintenance requests, and community updates. Simplify your living experience today!",
  "property_seo_title_referafriend": "Refer A Friend | Brookwood Village",
  "property_seo_description_referafriend": "Share the joy of living at Brookwood Village! Refer a friend and enjoy a vibrant community in Oklahoma City, where great friends become great neighbors.",
  "property_seo_title_scheduletour": "Schedule a Tour - Brookwood Village Apartments - Oklahoma City, OK",
  "property_seo_description_scheduletour": "Tour Brookwood Village Apartments in Oklahoma City, OK. Tour flexibly, in person, virtually, or self-guided. Schedule today.",
  "property_seo_title_privacy": "Privacy Policy | Brookwood Village",
  "property_seo_description_privacy": "At Brookwood Village in Oklahoma City, your privacy matters. Dive into our comprehensive privacy policy to see how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Brookwood Village",
  "property_seo_description_accessibility": "At Brookwood Village in Oklahoma City, we prioritize accessibility and digital inclusion, ensuring everyone enjoys a seamless online experience. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Brookwood Village",
  "property_seo_description_sitemap": "Navigate Brookwood Village's charming community in Oklahoma City! Find everything you need easily—view our sitemap and discover your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Brookwood Village",
  "property_seo_description_thankyou": "Thank you for reaching out to Brookwood Village! We're excited to connect. Your new home in Oklahoma City awaits—stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764150",
  "amenities": [
    {
      "id": "ec_b22228ef1affb3b710896820",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378441",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eedc1cd49c7a30298157c45b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378442",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_568565900b5231fd1f3d1ad4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378445",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5784339ac5643f313434f3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378448",
      "title": "Laundry Facilities/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c42c53d78e982e6fb64e632",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378449",
      "title": "Reservable Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d9a34-0cfe-7429-972e-7a4026d725d5.webp",
      "amenity_image_media": {
        "alt_text": "Community kitchen and seating area with large windows",
        "public_id": "019d9a34-0cfe-7429-972e-7a4026d725d5",
        "storage_key": "property/6767906449167180/019d9a34-0cfe-7429-972e-7a4026d725d5.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A kitchen and dining room with a grey carpet.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6904e057c8710ba797939ceb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378452",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2e6255b78ef43068cdc7406",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378453",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fef7d1f09ff61ebfc6707be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378454",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d9a33-f102-704c-801e-91a61730d6c9.webp",
      "amenity_image_media": {
        "alt_text": "Children's playground with slides, stairs, and climbing features.",
        "public_id": "019d9a33-f102-704c-801e-91a61730d6c9",
        "storage_key": "property/6767906449167180/019d9a33-f102-704c-801e-91a61730d6c9.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a playground with two slides and a monkey bars",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a91fa755db79a4ab3e26959",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378459",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d9a33-ef58-70dd-b71b-e44356cbf505.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor basketball court with hoop and buildings in the background.",
        "public_id": "019d9a33-ef58-70dd-b71b-e44356cbf505",
        "storage_key": "property/6767906449167180/019d9a33-ef58-70dd-b71b-e44356cbf505.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a basketball court with trees in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc6b808297539f8ff95fed25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378460",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d9a34-01cc-75d6-94ca-1ce735c058f1.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, ellipticals, rowing machine, and weight machines.",
        "public_id": "019d9a34-01cc-75d6-94ca-1ce735c058f1",
        "storage_key": "property/6767906449167180/019d9a34-01cc-75d6-94ca-1ce735c058f1.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A gym with a variety of equipment including treadmills, stationary bikes, and weight machines.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf4b6b0a40a42dbc680f090e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378461",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd3f74358d8aebdcfb2daef7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378462",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d9a33-ef4d-703b-bf19-c115a4b7321b.webp",
      "amenity_image_media": {
        "alt_text": "Tennis courts with fencing and trees in the background under a blue sky.",
        "public_id": "019d9a33-ef4d-703b-bf19-c115a4b7321b",
        "storage_key": "property/6767906449167180/019d9a33-ef4d-703b-bf19-c115a4b7321b.webp",
        "width": 1024,
        "height": 687
      },
      "amenity_image_alt_text": "a tennis court with trees in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_153132599fbf4fd433444f92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378463",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-6aad-753d-b0f0-bbe8ff7742e0.webp",
      "amenity_image_media": {
        "alt_text": "Sand volleyball court with a net and poles, surrounded by trees.",
        "public_id": "019d08c2-6aad-753d-b0f0-bbe8ff7742e0",
        "storage_key": "property/6767906449167180/019d08c2-6aad-753d-b0f0-bbe8ff7742e0.webp",
        "width": 1500,
        "height": 1000
      },
      "amenity_image_alt_text": "a volleyball court with trees in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_988c91357380c477c3ba319c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378468",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc3890221fdf4e18db9b76af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378470",
      "title": "Central AC and Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16c9ffecb5715560857697d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378472",
      "title": "Patio/Balcony in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_379e8b0c10914c76963d8491",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378475",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-fdc7-723b-ba8a-b9b77a96c5a4.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with shelves and a laundry hamper.",
        "public_id": "019d021c-fdc7-723b-ba8a-b9b77a96c5a4",
        "storage_key": "property/6767906449167180/019d021c-fdc7-723b-ba8a-b9b77a96c5a4.webp",
        "width": 1920,
        "height": 1080
      },
      "amenity_image_alt_text": "a walk in closet in a 555 waverly unit",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e7a1a963fd92121c2ca92f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378444",
      "title": "Bilingual Leasing Team Members",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08bd92a4a7000a6bbda9bfbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378446",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d65ef308cc23b45df67e1586",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378473",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-51a5-7610-b74a-3bc087d4ab19.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with a round dining table and four seats, a refrigerator, and white cabinets.",
        "public_id": "019d021d-51a5-7610-b74a-3bc087d4ab19",
        "storage_key": "property/6767906449167180/019d021d-51a5-7610-b74a-3bc087d4ab19.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a dining room with a table and three stools",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2aa5f01bea7ce31c3efd249",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378450",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_486514537c1081209150436a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "121234197",
      "title": "Plank Style Flooring in Select 1st Floor Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-f216-7067-b592-79eacafa4ed9.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with stairs leading to a loft and an open kitchen area.",
        "public_id": "019d021c-f216-7067-b592-79eacafa4ed9",
        "storage_key": "property/6767906449167180/019d021c-f216-7067-b592-79eacafa4ed9.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a living room with a couch and a chair",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8801ce72fb0d689c562fed74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "121234212",
      "title": "Ample Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-53e6-71d8-ab78-4f74397d141f.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and storage cabinets.",
        "public_id": "019d021d-53e6-71d8-ab78-4f74397d141f",
        "storage_key": "property/6767906449167180/019d021d-53e6-71d8-ab78-4f74397d141f.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a bathroom with a sink and a refrigerator",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63eec279d9ce37ab25a55bdb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378451",
      "title": "Game room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_20b405dcd6d8d6b5c9f49399",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378455",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-464e-74fd-b14b-2be944f719fe.webp",
      "amenity_image_media": {
        "alt_text": "Apartment buildings with a picnic table and grill in a grassy courtyard.",
        "public_id": "019d021d-464e-74fd-b14b-2be944f719fe",
        "storage_key": "property/6767906449167180/019d021d-464e-74fd-b14b-2be944f719fe.webp",
        "width": 1023,
        "height": 682
      },
      "amenity_image_alt_text": "Brookwood Village Picnic Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_992d1dff0824e4668afc522e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378456",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-4615-7799-b2cd-25f22925b108.webp",
      "amenity_image_media": {
        "alt_text": "A fenced-in dog park with agility equipment, a tunnel, and benches on a sunny day.",
        "public_id": "019d021d-4615-7799-b2cd-25f22925b108",
        "storage_key": "property/6767906449167180/019d021d-4615-7799-b2cd-25f22925b108.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a large grassy area with a trampoline and other playground equipment",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eaea0e0442d8b1c6a50ced31",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378457",
      "title": "Pond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-4612-735b-9d5d-bebd5d589b50.webp",
      "amenity_image_media": {
        "alt_text": "Pond with fountain and geese, surrounded by trees.",
        "public_id": "019d021d-4612-735b-9d5d-bebd5d589b50",
        "storage_key": "property/6767906449167180/019d021d-4612-735b-9d5d-bebd5d589b50.webp",
        "width": 1024,
        "height": 684
      },
      "amenity_image_alt_text": "a lake with a fountain in the middle of it",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cc64a0cdfde07fb0a348fea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378458",
      "title": "Putting Greens",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_322f8baabd7a4e677763df6e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378465",
      "title": "Sport Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-460c-7268-be2d-7d6c6793a31c.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a sports court with a blue stylized 'W' logo.",
        "public_id": "019d021d-460c-7268-be2d-7d6c6793a31c",
        "storage_key": "property/6767906449167180/019d021d-460c-7268-be2d-7d6c6793a31c.webp",
        "width": 1500,
        "height": 843
      },
      "amenity_image_alt_text": "an aerial view of a parking lot with a red truck parked on top of it",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8edfa966c32bba354d42ccd3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "124799811",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b6e8b8b805cca5157c315e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "86378467",
      "title": "Nature Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-516a-777b-a6d5-0852475ff98e.webp",
      "amenity_image_media": {
        "alt_text": "Wooden bridge with brown railings leading into a park with green trees and grass.",
        "public_id": "019d021d-516a-777b-a6d5-0852475ff98e",
        "storage_key": "property/6767906449167180/019d021d-516a-777b-a6d5-0852475ff98e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a bridge over a grassy area with trees",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_14d66f90725ac66ed2ee7825",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-f216-7067-b592-79eacafa4ed9.webp",
      "image_media": {
        "alt_text": "Modern living room with stairs leading to a loft and an open kitchen area.",
        "public_id": "019d021c-f216-7067-b592-79eacafa4ed9",
        "storage_key": "property/6767906449167180/019d021c-f216-7067-b592-79eacafa4ed9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a comfortable sofa, accent chair, and a modern staircase. The open-concept layout seamlessly connects to the kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "A cozy living room here at Brookwood Village with wood-style flooring, soft neutral furnishings, and warm lighting, featuring an open layout with a staircase, a small dining area, and a connected kitchen that creates an inviting and functional living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(1).JPG"
    },
    {
      "id": "ec_4c737cd184b14d9901e9f377",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-f21f-73a9-a885-6c91ed94d70a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel sink, white appliances, and decorative wall art.",
        "public_id": "019d021c-f21f-73a9-a885-6c91ed94d70a",
        "storage_key": "property/6767906449167180/019d021c-f21f-73a9-a885-6c91ed94d70a.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample white cabinetry, a double basin sink, and a full suite of appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "A bright kitchen here at Brookwood Village with white cabinets, light countertops, and white appliances, featuring a galley-style layout, wood-style flooring, and soft neutral accents that create a clean and welcoming cooking space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(2).JPG"
    },
    {
      "id": "ec_e631e1b5ef4de1d4bb5a7506",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-f261-76d0-950b-88f6585e0150.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a glass-top table and four chairs",
        "public_id": "019d021c-f261-76d0-950b-88f6585e0150",
        "storage_key": "property/6767906449167180/019d021c-f261-76d0-950b-88f6585e0150.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy meals in your bright and airy kitchen and dining area, perfect for casual dinners or entertaining guests.",
      "link": "false",
      "alt_text": "A charming dining area here at Brookwood Village with wood-style flooring, a round glass-top table, and warm accent lighting, featuring an open view into the kitchen that creates a comfortable and connected dining space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(3).JPG"
    },
    {
      "id": "ec_d43d50ac6d355793db739908",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-f3ff-777f-bfff-01c9df1d30c0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, yellow and white bedding, and a dark wood headboard.",
        "public_id": "019d021c-f3ff-777f-bfff-01c9df1d30c0",
        "storage_key": "property/6767906449167180/019d021c-f3ff-777f-bfff-01c9df1d30c0.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable queen-size bed with plush yellow and white linens. Perfect for relaxation.",
      "link": "false",
      "alt_text": "A bright bedroom here at Brookwood Village with beige carpet, soft neutral walls, and natural light from multiple windows, featuring a cozy bed with warm accent bedding and an open, airy layout that feels calm and inviting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(4).jpg"
    },
    {
      "id": "ec_16ebbd2abd9df4642e6a5802",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-365c-74bf-a9e7-3d478391bf72.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
        "public_id": "019d08c2-365c-74bf-a9e7-3d478391bf72",
        "storage_key": "property/6767906449167180/019d08c2-365c-74bf-a9e7-3d478391bf72.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a dresser with decorative items, and access to a closet. ",
      "link": "false",
      "alt_text": "A bedroom with a bed, dresser, and nightstand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(14).JPG"
    },
    {
      "id": "ec_d045ffb9e1b5e8debfedd3bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-fdc7-723b-ba8a-b5c627cc3c86.webp",
      "image_media": {
        "alt_text": "Bathroom with a white toilet, vanity, and shower",
        "public_id": "019d021c-fdc7-723b-ba8a-b5c627cc3c86",
        "storage_key": "property/6767906449167180/019d021c-fdc7-723b-ba8a-b5c627cc3c86.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Clean and modern bathroom featuring a white toilet, vanity with sink and mirror, and a bathtub with a patterned shower curtain.",
      "link": "false",
      "alt_text": "A bathroom with a toilet, sink, and shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(15).JPG"
    },
    {
      "id": "ec_8483c935be482cf00c61a9c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-357b-76f9-86d9-adc5bcdae630.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower curtain.",
        "public_id": "019d08c2-357b-76f9-86d9-adc5bcdae630",
        "storage_key": "property/6767906449167180/019d08c2-357b-76f9-86d9-adc5bcdae630.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a spacious vanity with a sink, a toilet, and a bathtub with a shower curtain.",
      "link": "false",
      "alt_text": "A white bathroom with a towel on the towel rack.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(16).JPG"
    },
    {
      "id": "ec_50897b90966968debb603999",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021c-fdc7-723b-ba8a-b9b77a96c5a4.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and a laundry hamper.",
        "public_id": "019d021c-fdc7-723b-ba8a-b9b77a96c5a4",
        "storage_key": "property/6767906449167180/019d021c-fdc7-723b-ba8a-b9b77a96c5a4.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and a convenient laundry hamper, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "A small, white closet with a white door and a white wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(17).JPG"
    },
    {
      "id": "ec_e3fdf8735fb6af73a18b8636",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-3a41-7147-bc48-7216a82f2d9c.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, a white refrigerator, and a stove.",
        "public_id": "019d08c2-3a41-7147-bc48-7216a82f2d9c",
        "storage_key": "property/6767906449167180/019d08c2-3a41-7147-bc48-7216a82f2d9c.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white cabinetry, a refrigerator, stove, and sink area.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(18).JPG"
    },
    {
      "id": "ec_01cadddce0edfa11ee24d4b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-4264-76ba-899f-0104f888c03d.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and bathroom doors open",
        "public_id": "019d08c2-4264-76ba-899f-0104f888c03d",
        "storage_key": "property/6767906449167180/019d08c2-4264-76ba-899f-0104f888c03d.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "View of a bedroom showcasing its closet and access to the bathroom. The neutral carpet and white walls create a clean, inviting space.",
      "link": "false",
      "alt_text": "A room with a carpeted floor and two doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(19).JPG"
    },
    {
      "id": "ec_24124a672d34cc814b9bfa63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-4572-76a8-bbbd-96df01080f32.webp",
      "image_media": {
        "alt_text": "Living room with carpet and blinds.",
        "public_id": "019d08c2-4572-76a8-bbbd-96df01080f32",
        "storage_key": "property/6767906449167180/019d08c2-4572-76a8-bbbd-96df01080f32.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious living room with plush carpeting and large windows, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "A room with a carpeted floor and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(20).JPG"
    },
    {
      "id": "ec_55a0dd3a988414c8f483569a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-017b-74ac-b9ed-504595bee468.webp",
      "image_media": {
        "alt_text": "Modern reception desk in a spacious, well-lit lobby with contemporary lighting and artwork.",
        "public_id": "019d021d-017b-74ac-b9ed-504595bee468",
        "storage_key": "property/6767906449167180/019d021d-017b-74ac-b9ed-504595bee468.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our lobby, where a sleek reception desk awaits. The space features modern lighting, elegant decor, and a bright, inviting atmosphere.",
      "link": "false",
      "alt_text": "A reception desk with a plant on it and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(21).jpg"
    },
    {
      "id": "ec_df523de65c2092715ed2bdfd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-4af5-771f-b523-3b7833d5c4f1.webp",
      "image_media": {
        "alt_text": "Community room with large table and chairs, large windows, and exit sign.",
        "public_id": "019d08c2-4af5-771f-b523-3b7833d5c4f1",
        "storage_key": "property/6767906449167180/019d08c2-4af5-771f-b523-3b7833d5c4f1.webp",
        "width": 1499,
        "height": 999
      },
      "title": "Community",
      "description": "Enjoy communal spaces like this community room, perfect for gatherings and events. Features comfortable seating and abundant natural light.",
      "link": "false",
      "alt_text": "A conference room with a long table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(22).jpg"
    },
    {
      "id": "ec_4fac995a2ff57f55de41a8a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-01a0-7088-9f6e-82308f81f907.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019d021d-01a0-7088-9f6e-82308f81f907",
        "storage_key": "property/6767906449167180/019d021d-01a0-7088-9f6e-82308f81f907.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring a variety of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "A spacious gym with a variety of equipment and a carpeted floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(23).jpg"
    },
    {
      "id": "ec_eba4851e7e20e0e92e955285",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-54dc-760f-a891-4b288f75dbc3.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, ellipticals, a rowing machine, and weight machines.",
        "public_id": "019d08c2-54dc-760f-a891-4b288f75dbc3",
        "storage_key": "property/6767906449167180/019d08c2-54dc-760f-a891-4b288f75dbc3.webp",
        "width": 1498,
        "height": 999
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio machines and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "A gym with a variety of equipment including treadmills, stationary bikes, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(24).jpg"
    },
    {
      "id": "ec_6d95690165e314b37559c5a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-0c17-760a-8c69-f7828c4bc38e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge area and apartment buildings in background.",
        "public_id": "019d021d-0c17-760a-8c69-f7828c4bc38e",
        "storage_key": "property/6767906449167180/019d021d-0c17-760a-8c69-f7828c4bc38e.webp",
        "width": 1650,
        "height": 926
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing and soaking up the sun. Located conveniently near the apartment buildings for easy access.",
      "link": "false",
      "alt_text": "A swimming pool in front of a house with a fence around it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(25).jpg"
    },
    {
      "id": "ec_6f477d71482cc539dd3ce12f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019e86e9-7467-76eb-8530-dcea398bec0b.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019e86e9-7467-76eb-8530-dcea398bec0b",
        "storage_key": "property/6767906449167180/019e86e9-7467-76eb-8530-dcea398bec0b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas. A perfect oasis for relaxation and fun.",
      "link": "false",
      "alt_text": "A swimming pool surrounded by trees and a house in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(38).jpg"
    },
    {
      "id": "ec_1ef05546ef5a39f5c24ef8e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019e86e9-7463-728a-80ed-f24442c6bc60.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019e86e9-7463-728a-80ed-f24442c6bc60",
        "storage_key": "property/6767906449167180/019e86e9-7463-728a-80ed-f24442c6bc60.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "false",
      "alt_text": "A large swimming pool surrounded by trees and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(39).jpg"
    },
    {
      "id": "ec_406dd6d9ba0930c3c51d5352",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019e86e9-75f5-755e-a816-f23d0a53b0ff.webp",
      "image_media": {
        "alt_text": "Picnic area with grills and seating surrounded by trees and landscaping.",
        "public_id": "019e86e9-75f5-755e-a816-f23d0a53b0ff",
        "storage_key": "property/6767906449167180/019e86e9-75f5-755e-a816-f23d0a53b0ff.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community picnic area, complete with grills and comfortable seating amidst beautiful greenery.",
      "link": "false",
      "alt_text": "A park with a bench and a tree.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(40).jpg"
    },
    {
      "id": "ec_8be5d1f2ef98fb40ff6e05c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d08c2-6aad-753d-b0f0-bbe8ff7742e0.webp",
      "image_media": {
        "alt_text": "Sand volleyball court with a net and poles, surrounded by trees.",
        "public_id": "019d08c2-6aad-753d-b0f0-bbe8ff7742e0",
        "storage_key": "property/6767906449167180/019d08c2-6aad-753d-b0f0-bbe8ff7742e0.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a game of volleyball on our sandy court, perfect for outdoor fun and community gathering.",
      "link": "false",
      "alt_text": "A sandy area with a goal post in the middle of it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(41).jpg"
    },
    {
      "id": "ec_1c759ddf76b24b8b535cc2e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-0eb7-756c-a68a-a99c026ba8be.webp",
      "image_media": {
        "alt_text": "Wooden bridge overlooking a playground with apartment buildings in the background.",
        "public_id": "019d021d-0eb7-756c-a68a-a99c026ba8be",
        "storage_key": "property/6767906449167180/019d021d-0eb7-756c-a68a-a99c026ba8be.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community playground and scenic bridge, perfect for family fun and relaxation.",
      "link": "false",
      "alt_text": "A wooden bridge leads to a playground in a park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(42).jpg"
    },
    {
      "id": "ec_f7766c914afcaffa223efdee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-108b-7506-8573-aec17bb2e53e.webp",
      "image_media": {
        "alt_text": "Spacious and elegant community lounge area with a grand staircase, plush seating, and large windows.",
        "public_id": "019d021d-108b-7506-8573-aec17bb2e53e",
        "storage_key": "property/6767906449167180/019d021d-108b-7506-8573-aec17bb2e53e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge. Features comfortable seating, elegant decor, and ample natural light.",
      "link": "false",
      "alt_text": "A large, well-lit room with a staircase and comfortable seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(43).jpg"
    },
    {
      "id": "ec_b8a8decda3a33dabb8dd400f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019dc334-334f-7758-8497-0fb7a0d9096b.webp",
      "image_media": {
        "alt_text": "Children's playground with red slide and climbing structures.",
        "public_id": "019dc334-334f-7758-8497-0fb7a0d9096b",
        "storage_key": "property/6767906449167180/019dc334-334f-7758-8497-0fb7a0d9096b.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a vibrant red slide and safe climbing structures for endless entertainment.",
      "link": "false",
      "alt_text": "A playground with a red slide and a green roofed structure.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(44).jpg"
    },
    {
      "id": "ec_ee733ec819e0eacb30bd045e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-460c-7268-be2d-7d6c6793a31c.webp",
      "image_media": {
        "alt_text": "Aerial view of a sports court with a blue stylized 'W' logo.",
        "public_id": "019d021d-460c-7268-be2d-7d6c6793a31c",
        "storage_key": "property/6767906449167180/019d021d-460c-7268-be2d-7d6c6793a31c.webp",
        "width": 1500,
        "height": 843
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our sports court, featuring a vibrant blue 'W' logo. Perfect for a friendly game or some active fun.",
      "link": "false",
      "alt_text": "A basketball court with blue lines painted on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(45).jpg"
    },
    {
      "id": "ec_f5d99111ccb7bb7af868b5fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019dc334-3218-71e3-8e1a-c63d7f959e35.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, including a tunnel, balance beam, and A-frame.",
        "public_id": "019dc334-3218-71e3-8e1a-c63d7f959e35",
        "storage_key": "property/6767906449167180/019dc334-3218-71e3-8e1a-c63d7f959e35.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring fun agility equipment for your furry friends to play and exercise.",
      "link": "false",
      "alt_text": "A playground with a blue tarp and a red barrel.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(46).jpg"
    },
    {
      "id": "ec_cb8fa6aef0caa2405ce3ea4f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019dc334-3474-709e-9b32-14a93f7effa5.webp",
      "image_media": {
        "alt_text": "Peaceful park bench overlooking a tranquil pond surrounded by lush greenery and trees under a clear blue sky.",
        "public_id": "019dc334-3474-709e-9b32-14a93f7effa5",
        "storage_key": "property/6767906449167180/019dc334-3474-709e-9b32-14a93f7effa5.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy the serenity of our community with this beautiful outdoor space, featuring a peaceful pond, walking paths, and ample seating for relaxation.",
      "link": "false",
      "alt_text": "A bench sits on a grassy area next to a body of water with trees in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(47).jpg"
    },
    {
      "id": "ec_ce3dc13e673f82d49ee0d798",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-4612-735b-9d5d-bebd5d589b50.webp",
      "image_media": {
        "alt_text": "Pond with fountain and geese, surrounded by trees.",
        "public_id": "019d021d-4612-735b-9d5d-bebd5d589b50",
        "storage_key": "property/6767906449167180/019d021d-4612-735b-9d5d-bebd5d589b50.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Enjoy the serene atmosphere of our community pond, complete with a soothing fountain and playful geese. A perfect spot for relaxation and enjoying nature.",
      "link": "false",
      "alt_text": "A fountain in the middle of a lake with a duck jumping into the water.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(48).JPG"
    },
    {
      "id": "ec_d510a96aaef81395aa80eebb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-516a-777b-a6d5-0852475ff98e.webp",
      "image_media": {
        "alt_text": "Wooden bridge with brown railings leading into a park with green trees and grass.",
        "public_id": "019d021d-516a-777b-a6d5-0852475ff98e",
        "storage_key": "property/6767906449167180/019d021d-516a-777b-a6d5-0852475ff98e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy the scenic walking paths and lush greenery surrounding the property with this picturesque bridge.",
      "link": "false",
      "alt_text": "A bridge with a metal railing and a wooden walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(49).JPG"
    },
    {
      "id": "ec_251ee5279896f48e913420d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-464e-74fd-b14b-2be944f719fe.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a picnic table and grill in a grassy courtyard.",
        "public_id": "019d021d-464e-74fd-b14b-2be944f719fe",
        "storage_key": "property/6767906449167180/019d021d-464e-74fd-b14b-2be944f719fe.webp",
        "width": 1023,
        "height": 682
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community picnic tables and grills, perfect for gathering with friends and neighbors.",
      "link": "false",
      "alt_text": "A grassy area with a picnic table and benches in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(50).JPG"
    },
    {
      "id": "ec_28da16c74617d8700ead743d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d9a33-ef4d-703b-bf19-c115a4b7321b.webp",
      "image_media": {
        "alt_text": "Tennis courts with fencing and trees in the background under a blue sky.",
        "public_id": "019d9a33-ef4d-703b-bf19-c115a4b7321b",
        "storage_key": "property/6767906449167180/019d9a33-ef4d-703b-bf19-c115a4b7321b.webp",
        "width": 1024,
        "height": 687
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our pristine tennis courts, perfect for staying active and having fun outdoors.",
      "link": "false",
      "alt_text": "A tennis court surrounded by a fence and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Brookwood_Village_Favorites%20(51).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2176c2bc-9e1b-4e7a-b072-9fa8eedd91e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Green Plus",
      "poi_type": "Shopping & Retail",
      "poi_address": "8613 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-328c-75f0-960b-6715ef9694fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-328c-75f0-960b-6715ef9694fe",
        "storage_key": "property/6767906449167180/01a14134-328c-75f0-960b-6715ef9694fe.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://shorturl.at/xjp2A",
      "poi_directions_map_url": "https://maps.google.com/?cid=13182449528716786429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-plus",
      "poi_latitude": "35.3795408",
      "poi_longitude": "-97.530459",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-903b-703a-8597-f22a6d5dbc4c",
        "storage_key": "property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA9WQ5MwTsocR_fqttAB48bY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e15634c0-da68-48e9-9ae5-9b1224d27aad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Walker Donut",
      "poi_type": "Restaurants",
      "poi_address": "7390 S Walker Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Welcoming donut shop offering fresh donuts and croissant sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-3b62-704d-b92f-0c67bf3b15a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-3b62-704d-b92f-0c67bf3b15a4",
        "storage_key": "property/6767906449167180/01a14134-3b62-704d-b92f-0c67bf3b15a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.online/business/walker-donut-11349933",
      "poi_directions_map_url": "https://maps.google.com/?cid=5698279781956901782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walker-donut",
      "poi_latitude": "35.3932171",
      "poi_longitude": "-97.5208175",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-429-4008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiUxUPnQUsocRlttUWkVbFE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_b08f9772-0273-4112-8f32-de25cbd74361",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Sunnyside Diner",
      "poi_type": "Restaurants",
      "poi_address": "824 SW 89th St, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Vintage-style diner serving hearty breakfast favorites like pancakes, cinnamon rolls, and diverse vegan options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-31cf-7038-b178-d28fafdbc6c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-31cf-7038-b178-d28fafdbc6c3",
        "storage_key": "property/6767906449167180/01a14134-31cf-7038-b178-d28fafdbc6c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://eatatsunnyside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17679992004354530254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunnyside-diner",
      "poi_latitude": "35.3767861",
      "poi_longitude": "-97.52895",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-703-0011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwF_loETsocRzltMKw7zW_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_030397ad-06c0-4b8f-8723-f2f3d88ace14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "7916 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-2fcc-73ab-900c-b137ebda70ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-2fcc-73ab-900c-b137ebda70ef",
        "storage_key": "property/6767906449167180/01a14134-2fcc-73ab-900c-b137ebda70ef.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=650338632903679053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scooters-coffee",
      "poi_latitude": "35.3876912",
      "poi_longitude": "-97.5295474",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-768-5148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96fa-710e-894b-aaec355cf865.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96fa-710e-894b-aaec355cf865",
        "storage_key": "property/6767906449167180/019d021e-96fa-710e-894b-aaec355cf865.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJOZOQeAITsocRTdzvfYp3Bgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_9a23c108-242e-425c-a435-3ffa634b6e21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "9100 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-32e1-742b-b12b-84f61224e5f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-32e1-742b-b12b-84f61224e5f4",
        "storage_key": "property/6767906449167180/01a14134-32e1-742b-b12b-84f61224e5f4.webp",
        "width": 962,
        "height": 1280
      },
      "poi_business_url": "https://www.dunkindonuts.com/locations/us/ok/oklahoma-city/9100-s-western-ave/store-354523/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=354523&y_source=1_MTIxMTIxMzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6194980654347379602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "35.3761303",
      "poi_longitude": "-97.5296152",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-845-3141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96fa-710e-894b-aaec355cf865.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96fa-710e-894b-aaec355cf865",
        "storage_key": "property/6767906449167180/019d021e-96fa-710e-894b-aaec355cf865.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJETnK84ETsocRkuPKLBX--FU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c1fc446c-5ff5-4edc-b195-dbafca96edfe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Freddy's Frozen Custard & Steakburgers",
      "poi_type": "Restaurants",
      "poi_address": "9000 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_long_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-2faf-76fd-9308-b1e0530500db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-2faf-76fd-9308-b1e0530500db",
        "storage_key": "property/6767906449167180/01a14134-2faf-76fd-9308-b1e0530500db.webp",
        "width": 540,
        "height": 960
      },
      "poi_business_url": "https://www.freddys.com/location/okc-brookwood-ok?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10522609442841596724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freddys-frozen-custard--steakburgers",
      "poi_latitude": "35.376750099999995",
      "poi_longitude": "-97.5295947",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-692-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1x6Mh4ETsocRNJO-fonRB5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1d300ca1-e7ba-4731-8449-32f72975e13e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "9101 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_long_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-366b-7699-a759-4b87e783c52a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-366b-7699-a759-4b87e783c52a",
        "storage_key": "property/6767906449167180/01a14134-366b-7699-a759-4b87e783c52a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4194165513340510920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-grill--bar",
      "poi_latitude": "35.3762634",
      "poi_longitude": "-97.5306014",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-691-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJscCNGYITsocRyOLaD1CrNDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_f71907aa-d9b6-4dd3-8f35-c377b16d5e0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Tom & Chee",
      "poi_type": "Restaurants",
      "poi_address": "9201 S Western Ave Suite A, Oklahoma City, OK 73139, USA",
      "poi_short_description": "No-frills local chain serving creative takes on grilled cheese sandwiches, tomato soups & salads.",
      "poi_long_description": "No-frills local chain serving creative takes on grilled cheese sandwiches, tomato soups & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-3b5f-74ac-806c-0153480092fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-3b5f-74ac-806c-0153480092fc",
        "storage_key": "property/6767906449167180/01a14134-3b5f-74ac-806c-0153480092fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tomandchee.com/join-the-team",
      "poi_directions_map_url": "https://maps.google.com/?cid=9466765025635085290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom--chee",
      "poi_latitude": "35.3750802",
      "poi_longitude": "-97.5304652",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-735-7173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHS_N5WcTsocR6isSPaK0YIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0291be5f-a536-462a-8e9a-2a62b05b52d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Los Vaqueros",
      "poi_type": "Restaurants",
      "poi_address": "9122 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Traditional Mexican food prepared in a warm, family-run restaurant & bar with outdoor space.",
      "poi_long_description": "Traditional Mexican food prepared in a warm, family-run restaurant & bar with outdoor space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-33ba-73b5-bba7-9b544ec8dc5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-33ba-73b5-bba7-9b544ec8dc5f",
        "storage_key": "property/6767906449167180/01a14134-33ba-73b5-bba7-9b544ec8dc5f.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16603348697069551783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-vaqueros",
      "poi_latitude": "35.3750048",
      "poi_longitude": "-97.5296837",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-691-5830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWxo_4ETsocRp4DG8qvxauY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_67c6605b-ec5a-4592-b786-4b73131e0675",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Domino's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "9356 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Delivery, carryout & dine-in chain offering a wide range of pizzas, plus a variety of other dishes & sides.",
      "poi_long_description": "Delivery, carryout & dine-in chain offering a wide range of pizzas, plus a variety of other dishes & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-2f7d-72c0-9194-e6be4b951dd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-2f7d-72c0-9194-e6be4b951dd0",
        "storage_key": "property/6767906449167180/01a14134-2f7d-72c0-9194-e6be4b951dd0.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "https://www.dominos.com/en/?utm_source=google&utm_medium=loclist&utm_campaign=localmaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=773653942700341476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominos-pizza",
      "poi_latitude": "35.37461030000001",
      "poi_longitude": "-97.5296742",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-692-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44JM3YETsocR5Pi7cSmSvAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_delivery"
    },
    {
      "id": "custom_26d96b03-9a0a-4e5e-9f5c-9cb5502b7335",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Bill's Steakhouse & Saloon South",
      "poi_type": "Entertainment",
      "poi_address": "1013 SW 89th St, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Saloon-themed eatery featuring hearty American meals, cocktails & draft brews in a homey setting.",
      "poi_long_description": "Saloon-themed eatery featuring hearty American meals, cocktails & draft brews in a homey setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-3d6b-70d5-8f37-97d719b8c090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-3d6b-70d5-8f37-97d719b8c090",
        "storage_key": "property/6767906449167180/01a14134-3d6b-70d5-8f37-97d719b8c090.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://billssteakhouseandsaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18400083703101626443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bills-steakhouse--saloon-south",
      "poi_latitude": "35.3775005",
      "poi_longitude": "-97.5332448",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-225-1211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZx6TBYMTsocRS5jT4KM6Wv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_aa178589-3934-40cf-9831-5e48e0c4b258",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Swadley's Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "8317 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Regional chain doling out smoked ribs, brisket & homestyle sides in easygoing surrounds.",
      "poi_long_description": "Regional chain doling out smoked ribs, brisket & homestyle sides in easygoing surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-40f5-7698-b3e9-f2d18be9aeef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-40f5-7698-b3e9-f2d18be9aeef",
        "storage_key": "property/6767906449167180/01a14134-40f5-7698-b3e9-f2d18be9aeef.webp",
        "width": 1280,
        "height": 784
      },
      "poi_business_url": "https://swadleysbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9014978757601479406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swadleys-bar-b-q",
      "poi_latitude": "35.383060300000004",
      "poi_longitude": "-97.5306794",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-759-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb1Ro4ETsocR7kqHqGqjG30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_0baf5f2a-e02a-4fea-ab21-a9579e4857b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Johnny Carino's",
      "poi_type": "Restaurants",
      "poi_address": "7900 S Walker Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Classic Italian chain restaurant serving familiar & modern fare in a family-friendly setting.",
      "poi_long_description": "Classic Italian chain restaurant serving familiar & modern fare in a family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-3f6e-7421-9cae-5010c603ba96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-3f6e-7421-9cae-5010c603ba96",
        "storage_key": "property/6767906449167180/01a14134-3f6e-7421-9cae-5010c603ba96.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.carinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7962198387348211824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnny-carinos",
      "poi_latitude": "35.3884172",
      "poi_longitude": "-97.5207558",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-632-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE_K7EXcUsocRcAgUbT9pf24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f9b75d6b-3a4b-48b5-a705-a9fc6f4c877b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Mc Finns Pub",
      "poi_type": "Restaurants",
      "poi_address": "902 Straka Terrace, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Casual sports-themed dive bar featuring pool, darts, and jukebox entertainment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-420c-70c1-84bb-6b832ba1d500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-420c-70c1-84bb-6b832ba1d500",
        "storage_key": "property/6767906449167180/01a14134-420c-70c1-84bb-6b832ba1d500.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10426857759883245534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mc-finns-pub",
      "poi_latitude": "35.3872848",
      "poi_longitude": "-97.5308891",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-631-1026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-168f-752b-b395-bc7810ffd478.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-168f-752b-b395-bc7810ffd478",
        "storage_key": "property/6767906449167180/019d021f-168f-752b-b395-bc7810ffd478.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaCJN48TsocR3rddheOjs5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_c92dcd90-29c2-4f99-b022-1dc077de3807",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Panang - Thai Restaurant | S Penn",
      "poi_type": "Restaurants",
      "poi_address": "9022 S Pennsylvania Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Authentic Thai restaurant serving a variety of curries and signature soups.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-487d-72c9-a4c6-ea421ec5ce08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-487d-72c9-a4c6-ea421ec5ce08",
        "storage_key": "property/6767906449167180/01a14134-487d-72c9-a4c6-ea421ec5ce08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://panangthaifood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9999973629773087776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panang---thai-restaurant--s-penn",
      "poi_latitude": "35.3757383",
      "poi_longitude": "-97.5471645",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-691-9989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQTFJKATsocRIATmvQgLx4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_2d6b9624-1327-498a-8a82-71a816929874",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "911 SW 104th St, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Local grocery store featuring a pharmacy and various household essentials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-2caa-7765-9b30-35c4dba59af2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-2caa-7765-9b30-35c4dba59af2",
        "storage_key": "property/6767906449167180/019d021e-2caa-7765-9b30-35c4dba59af2.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/2878-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15642948604011728781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.3644961",
      "poi_longitude": "-97.5313266",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-692-3860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a9b-705f-8097-f46d8a5b0181.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a9b-705f-8097-f46d8a5b0181",
        "storage_key": "property/6767906449167180/019d021e-8a9b-705f-8097-f46d8a5b0181.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfOZTHsTsocRjc_PHeDqFtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6dffd4d0-8a3d-4411-832b-63a10c23782c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Aseda International Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "8960 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Grocery store known for selling high-quality produce, and African food.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-4be3-746d-8520-2b9ee919e7ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-4be3-746d-8520-2b9ee919e7ab",
        "storage_key": "property/6767906449167180/01a14134-4be3-746d-8520-2b9ee919e7ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9498317651315956507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aseda-international-grocery",
      "poi_latitude": "35.3776244",
      "poi_longitude": "-97.5285105",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-635-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a9b-705f-8097-f46d8a5b0181.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a9b-705f-8097-f46d8a5b0181",
        "storage_key": "property/6767906449167180/019d021e-8a9b-705f-8097-f46d8a5b0181.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPy58gIETsocRG5uCYpTN0IM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e7347931-7cad-44a9-8665-3dccf3e7524d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9001 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-48d4-726c-8d38-8713db2b9b34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-48d4-726c-8d38-8713db2b9b34",
        "storage_key": "property/6767906449167180/01a14134-48d4-726c-8d38-8713db2b9b34.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/oklahoma-city-ok-pharmacies/9001-s-western-ave-oklahoma-city-ok-73139/storeid=6016?WT.mc_id=LS_GOOGLE_RX_6016",
      "poi_directions_map_url": "https://maps.google.com/?cid=4860466080156698651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3766743",
      "poi_longitude": "-97.5307808",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-691-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-914c-764a-9524-b6a0010be280.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-914c-764a-9524-b6a0010be280",
        "storage_key": "property/6767906449167180/01a14134-914c-764a-9524-b6a0010be280.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ16xNO4ITsocRG0iT5iXYc0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0f80658e-5898-4fb0-a075-f2104b6d8b60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "9011 S Pennsylvania Ave Walgreens, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-3353-7368-aa42-90e85bdb00b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-3353-7368-aa42-90e85bdb00b1",
        "storage_key": "property/6767906449167180/019d021e-3353-7368-aa42-90e85bdb00b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-9011+s+pennsylvania+ave-oklahoma+city-ok-73159/id=3643",
      "poi_directions_map_url": "https://maps.google.com/?cid=7247465134596917634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.3761084",
      "poi_longitude": "-97.5484657",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-692-1882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8074TaATsocRgomtJSQrlGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_084bf1d8-8da3-405e-898c-399c6b893439",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9118 S Western Ave A, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Spacious, clean gym offering extensive exercise equipment and massage amenities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-63eb-76cc-93af-19946f4d6bbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-63eb-76cc-93af-19946f4d6bbf",
        "storage_key": "property/6767906449167180/019d021e-63eb-76cc-93af-19946f4d6bbf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-brookwood-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7943029326332511845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.3762027",
      "poi_longitude": "-97.5281104",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-237-3709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQsn6IETsocRZUaPnBZPO24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b989c84b-6f02-4af0-a871-1606d0eb8e79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Goodwill Thrift Store & Donation Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "9118 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-312f-762a-8266-55d307c29b0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-312f-762a-8266-55d307c29b0a",
        "storage_key": "property/6767906449167180/019d021e-312f-762a-8266-55d307c29b0a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://okgoodwill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14762303071897686864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodwill-thrift-store--donation-center",
      "poi_latitude": "35.3754334",
      "poi_longitude": "-97.5282935",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-703-7211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-903b-703a-8597-f22a6d5dbc4c",
        "storage_key": "property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlVtc9YETsocRUJMeC2483sw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_d7050ad6-a48a-4cc6-a523-9d5d8e120f9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Game HQ",
      "poi_type": "Shopping & Retail",
      "poi_address": "9118 S Western Ave B, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Expansive game store featuring a diverse selection of board games, RPGs, and miniatures alongside a large dedicated gaming space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-4c9a-734b-9d55-6b640561c126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-4c9a-734b-9d55-6b640561c126",
        "storage_key": "property/6767906449167180/01a14134-4c9a-734b-9d55-6b640561c126.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gameheadquarters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5033571783066552433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "game-hq",
      "poi_latitude": "35.3758178",
      "poi_longitude": "-97.5280162",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-691-0509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-903b-703a-8597-f22a6d5dbc4c",
        "storage_key": "property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2TEVMrskIRURcYgcId7W2kU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3705d29f-efbf-4dd2-ae86-142328b7bc36",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Bricks & Minifigs OKC Central",
      "poi_type": "Shopping & Retail",
      "poi_address": "9118 S Western Ave Ste E, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Specialized toy store featuring a wide selection of LEGO sets, minifigures, and bulk bricks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-4c30-70b0-a64f-2cbb9b92315d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-4c30-70b0-a64f-2cbb9b92315d",
        "storage_key": "property/6767906449167180/01a14134-4c30-70b0-a64f-2cbb9b92315d.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://bricksandminifigs.com/centraloklahomacity-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4672423729303146963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bricks--minifigs-okc-central",
      "poi_latitude": "35.375637399999995",
      "poi_longitude": "-97.5280689",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-735-7356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-903b-703a-8597-f22a6d5dbc4c",
        "storage_key": "property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnaIP9W4TsocR01E4UaDI10A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "toy_store"
    },
    {
      "id": "custom_0263b749-a0e6-4ef4-ab19-12d8d5025544",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Flying Eagle Coins PM007482",
      "poi_type": "Shopping & Retail",
      "poi_address": "9118 S Walker Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Knowledgeable coin shop offering fair prices on gold, silver, and collectibles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5359-74dc-8212-5fa713035e67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5359-74dc-8212-5fa713035e67",
        "storage_key": "property/6767906449167180/01a14134-5359-74dc-8212-5fa713035e67.webp",
        "width": 1280,
        "height": 762
      },
      "poi_business_url": "http://flyingeaglecoin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5476798369699678476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-eagle-coins-pm007482",
      "poi_latitude": "35.375789",
      "poi_longitude": "-97.520377",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-600-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-903b-703a-8597-f22a6d5dbc4c",
        "storage_key": "property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-0gJJX4UsocRDEljlBl_AUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_17eea061-42ec-41be-833f-cae48024d8e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Once Upon A Child",
      "poi_type": "Shopping & Retail",
      "poi_address": "10400 S Western Ave #11, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Chain operation that buys & sells gently used items for children, including clothes, shoes & toys.",
      "poi_long_description": "Chain operation that buys & sells gently used items for children, including clothes, shoes & toys.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-51b6-7539-bc7f-4297b50e5652.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-51b6-7539-bc7f-4297b50e5652",
        "storage_key": "property/6767906449167180/01a14134-51b6-7539-bc7f-4297b50e5652.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://onceuponachild.com/locations/oklahoma-city-ok-south/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3318257181233712402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "once-upon-a-child",
      "poi_latitude": "35.3640882",
      "poi_longitude": "-97.5281374",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-735-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-903b-703a-8597-f22a6d5dbc4c",
        "storage_key": "property/6767906449167180/019d021e-903b-703a-8597-f22a6d5dbc4c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDfArNmMTsocREg3TUFPRDC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_5a8a6b79-cc73-4ea8-927b-1fe4768636c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Sky Ranch Elementary School",
      "poi_type": "Education",
      "poi_address": "9501 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://skyranch.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10857965614631586467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sky-ranch-elementary-school",
      "poi_latitude": "35.3722598",
      "poi_longitude": "-97.5310705",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-735-4460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxAqNX8TsocRo4qF0zI-r5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_daab1264-cb4d-431b-a04c-9d3f39e1d28f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Moore West Junior High School",
      "poi_type": "Education",
      "poi_address": "9400 S Pennsylvania Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-389e-751f-88c0-b1f8b484b027.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-389e-751f-88c0-b1f8b484b027",
        "storage_key": "property/6767906449167180/019d021e-389e-751f-88c0-b1f8b484b027.webp",
        "width": 540,
        "height": 540
      },
      "poi_business_url": "https://moorewestjh.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4174722816113558026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moore-west-junior-high-school",
      "poi_latitude": "35.3727684",
      "poi_longitude": "-97.5461959",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-735-4620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQxZ1mAoTsocRCsIqWkiY7zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_dcf079d3-a461-4165-8414-6d9ffc6df520",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Westmoore High School",
      "poi_type": "Education",
      "poi_address": "12613 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5206-704c-8a23-6bdae811b8e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5206-704c-8a23-6bdae811b8e5",
        "storage_key": "property/6767906449167180/01a14134-5206-704c-8a23-6bdae811b8e5.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://westmoorehs.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9023050078341389623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westmoore-high-school",
      "poi_latitude": "35.342411399999996",
      "poi_longitude": "-97.5342346",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-735-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvaTAo1oTsocRN10Zdj1QOH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7acea472-7caa-4027-a4bc-9ade7fe05673",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Mount St. Mary Catholic High School",
      "poi_type": "Education",
      "poi_address": "2801 S Shartel Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5597-762f-8f76-16de1f651c40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5597-762f-8f76-16de1f651c40",
        "storage_key": "property/6767906449167180/01a14134-5597-762f-8f76-16de1f651c40.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mountstmary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11537479600767645389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-st-mary-catholic-high-school",
      "poi_latitude": "35.4373255",
      "poi_longitude": "-97.5266183",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-631-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYXzbJEsRsocRzTYSl5FcHaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_49c269f5-e178-4824-9c8c-b735ae9fce07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Santa Fe South Penn Elementary School",
      "poi_type": "Education",
      "poi_address": "5325 S Pennsylvania Ave, Oklahoma City, OK 73119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5229-701b-8c3e-09f1e6e98454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5229-701b-8c3e-09f1e6e98454",
        "storage_key": "property/6767906449167180/01a14134-5229-701b-8c3e-09f1e6e98454.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sfspenn.santafesouth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14962109054205400237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santa-fe-south-penn-elementary-school",
      "poi_latitude": "35.412334099999995",
      "poi_longitude": "-97.5485102",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-681-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJac-5dd4TsocRrZSRgukWpM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_426e6c1e-356a-4aac-9878-978e9cfa2e27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Southern Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "7800 S Kentucky Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.okcps.org/southernhills",
      "poi_directions_map_url": "https://maps.google.com/?cid=14040980231828884669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-hills-elementary-school",
      "poi_latitude": "35.387496999999996",
      "poi_longitude": "-97.542209",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-587-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlabF_JYTsocRvUxx6CCV28I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_aabb5b7e-2296-41d2-8c66-641e6b48619a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Oklahoma City Community College",
      "poi_type": "Education",
      "poi_address": "7777 S May Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14131-dacc-713d-99b7-6856a9fa8dc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-dacc-713d-99b7-6856a9fa8dc8",
        "storage_key": "property/6767906449167180/01a14131-dacc-713d-99b7-6856a9fa8dc8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.occc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12663331797127596950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-city-community-college",
      "poi_latitude": "35.3880406",
      "poi_longitude": "-97.5699184",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-682-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq1zRlkwSsocRlguzIC0xva8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b1dd9c70-ded2-4c38-8572-7065a7a5c3a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Rose State College",
      "poi_type": "Education",
      "poi_address": "6420 SE 15th St, Midwest City, OK 73110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-55b5-754a-bf87-1db2d602996f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-55b5-754a-bf87-1db2d602996f",
        "storage_key": "property/6767906449167180/01a14134-55b5-754a-bf87-1db2d602996f.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.rose.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16920593240303172125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rose-state-college",
      "poi_latitude": "35.4446054",
      "poi_longitude": "-97.4137767",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-733-7673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW2H9qcE9socRHXolJecF0uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_988fe553-7b66-4fc6-8c5e-a6deba58b952",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Oklahoma State University - Oklahoma City",
      "poi_type": "Education",
      "poi_address": "900 N Portland Ave, Oklahoma City, OK 73107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-590d-72e5-b181-dc7742cb8818.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-590d-72e5-b181-dc7742cb8818",
        "storage_key": "property/6767906449167180/01a14134-590d-72e5-b181-dc7742cb8818.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://osuokc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5945726857955521834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-state-university---oklahoma-city",
      "poi_latitude": "35.4748655",
      "poi_longitude": "-97.5818668",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-947-4421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGzr99UMQsocRKjXwUxN3g1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_631e7a45-2aa7-40c7-bc6b-d4a95fa1e808",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Childtime on South Western",
      "poi_type": "Education",
      "poi_address": "10212 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Supportive daycare center featuring educational programs and live-streaming classroom access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-4100-740e-aece-861bfbce665e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-4100-740e-aece-861bfbce665e",
        "storage_key": "property/6767906449167180/019d021e-4100-740e-aece-861bfbce665e.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.childtime.com/your-local-school/oklahoma-city-ok-0405/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=405",
      "poi_directions_map_url": "https://maps.google.com/?cid=16252440283238027807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childtime-on-south-western",
      "poi_latitude": "35.3659332",
      "poi_longitude": "-97.5294016",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 877-220-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902e-7149-99ea-3f80801d4fcc",
        "storage_key": "property/6767906449167180/019d021e-902e-7149-99ea-3f80801d4fcc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdZqwf3wTsocRH9KmF1REjOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_49252ed0-8ef1-4f33-85d1-0c1e59484810",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Winchester Drive-In",
      "poi_type": "Entertainment",
      "poi_address": "6930 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Oklahoma City's oldest drive-in movie theater is open seasonally & fits 475 cars.",
      "poi_long_description": "Oklahoma City's oldest drive-in movie theater is open seasonally & fits 475 cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-43f5-745b-a51e-192bc11819cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-43f5-745b-a51e-192bc11819cd",
        "storage_key": "property/6767906449167180/019d021e-43f5-745b-a51e-192bc11819cd.webp",
        "width": 967,
        "height": 803
      },
      "poi_business_url": "http://www.winchesterdrivein.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13189817087385337736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winchester-drive-in",
      "poi_latitude": "35.395929699999996",
      "poi_longitude": "-97.5273782",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-631-8851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-9036-728a-8320-efc090eb8287.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-9036-728a-8320-efc090eb8287",
        "storage_key": "property/6767906449167180/019d021e-9036-728a-8320-efc090eb8287.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSraI4sTsocRiP_6IcKkC7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_df2f3da8-1cba-44ea-8683-6c8b3369fa8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5991-75e1-828c-a06684e97d6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5991-75e1-828c-a06684e97d6e",
        "storage_key": "property/6767906449167180/01a14134-5991-75e1-828c-a06684e97d6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-902b-734a-a95c-13a7af1127bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-902b-734a-a95c-13a7af1127bb",
        "storage_key": "property/6767906449167180/019d021e-902b-734a-a95c-13a7af1127bb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0ca73a48-61bb-4aa6-821d-f85b9a2a80ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-601f-703d-b627-bbaa1e1ff641.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-601f-703d-b627-bbaa1e1ff641",
        "storage_key": "property/6767906449167180/01a14134-601f-703d-b627-bbaa1e1ff641.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.523889499999996",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-914c-764a-9524-b07575778d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-914c-764a-9524-b07575778d36",
        "storage_key": "property/6767906449167180/01a14134-914c-764a-9524-b07575778d36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_492e307a-24b6-4190-8896-5d4dad11d6ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Riversport Rapids",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Riversport Dr, Oklahoma City, OK 73129, USA",
      "poi_short_description": "Adventure-filled recreation center featuring white water rafting and various outdoor activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5974-756f-a275-d6b44b1ac649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5974-756f-a275-d6b44b1ac649",
        "storage_key": "property/6767906449167180/01a14134-5974-756f-a275-d6b44b1ac649.webp",
        "width": 960,
        "height": 671
      },
      "poi_business_url": "http://www.riversportokc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8162430927641999962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riversport-rapids",
      "poi_latitude": "35.4587826",
      "poi_longitude": "-97.5000424",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-552-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_ayN-EWsocRWnrDqa7HRnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_7a4132f4-0412-44f6-aa05-6def94fa84f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Brickopolis Family Entertainment Center",
      "poi_type": "Entertainment",
      "poi_address": "101 S Mickey Mantle Dr, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Family-friendly amusement center featuring multi-level arcade games and mini-golf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5a53-753a-93e9-09f723b7e720.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5a53-753a-93e9-09f723b7e720",
        "storage_key": "property/6767906449167180/01a14134-5a53-753a-93e9-09f723b7e720.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brickopolisu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14888340326159928071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brickopolis-family-entertainment-center",
      "poi_latitude": "35.465021799999995",
      "poi_longitude": "-97.5093175",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-516-2745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1WpOScXsocRB8viE6UCns4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_5bc59165-5ee3-4360-864c-14cb84cd1698",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Harkins Theatres Bricktown",
      "poi_type": "Entertainment",
      "poi_address": "150 E Reno Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-4a60-733f-8d5a-c5cd024d0ea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-4a60-733f-8d5a-c5cd024d0ea4",
        "storage_key": "property/6767906449167180/019d021e-4a60-733f-8d5a-c5cd024d0ea4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://harkins.com/theatres/bricktown?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1874330944030258537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harkins-theatres-bricktown",
      "poi_latitude": "35.4630849",
      "poi_longitude": "-97.5092174",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-231-4747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-9036-728a-8320-efc090eb8287.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-9036-728a-8320-efc090eb8287",
        "storage_key": "property/6767906449167180/019d021e-9036-728a-8320-efc090eb8287.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZuapdgWsocRaTVyHhD2Aho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a77bad85-6bb6-4b3e-a65e-f1ec1171923d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Chickasaw Bricktown Ballpark",
      "poi_type": "Entertainment",
      "poi_address": "2 S Mickey Mantle Dr, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Minor league baseball stadium hosting family-friendly games and entertainment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5d1f-7731-947c-2f573b9c64ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5d1f-7731-947c-2f573b9c64ae",
        "storage_key": "property/6767906449167180/01a14134-5d1f-7731-947c-2f573b9c64ae.webp",
        "width": 1280,
        "height": 901
      },
      "poi_business_url": "http://www.okccomets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18040532731312389442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chickasaw-bricktown-ballpark",
      "poi_latitude": "35.4649344",
      "poi_longitude": "-97.5087429",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-218-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1cc0-74f0-b7a4-46d9c9295c39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1cc0-74f0-b7a4-46d9c9295c39",
        "storage_key": "property/6767906449167180/019d021f-1cc0-74f0-b7a4-46d9c9295c39.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV6DhxiAXsocRQr2usO_YXPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3833e6df-f004-445d-877b-e6af71c3cb96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Oklahoma Film Exchange",
      "poi_type": "Entertainment",
      "poi_address": "701 W Sheridan Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5eac-705b-9ad5-5fdb30d5f509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5eac-705b-9ad5-5fdb30d5f509",
        "storage_key": "property/6767906449167180/01a14134-5eac-705b-9ad5-5fdb30d5f509.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.oklahomafilmexchange.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5801590102488535556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-film-exchange",
      "poi_latitude": "35.4668042",
      "poi_longitude": "-97.5244204",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-437-4635",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-9036-728a-8320-efc090eb8287.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-9036-728a-8320-efc090eb8287",
        "storage_key": "property/6767906449167180/019d021e-9036-728a-8320-efc090eb8287.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_R9Z1OwXsocRBFJAx3Vjg1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ee18d8e1-f951-4cba-91f0-a831da0e4290",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Tower Theatre",
      "poi_type": "Entertainment",
      "poi_address": "425 NW 23rd St, Oklahoma City, OK 73103, USA",
      "poi_short_description": "Historic performance site built in 1937, offering a stage for live music, a movie theater & gallery.",
      "poi_long_description": "Historic performance site built in 1937, offering a stage for live music, a movie theater & gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-5ef2-718a-872f-9f27398e1b79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-5ef2-718a-872f-9f27398e1b79",
        "storage_key": "property/6767906449167180/01a14134-5ef2-718a-872f-9f27398e1b79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://towertheatreokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17293270213962654783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-theatre",
      "poi_latitude": "35.4934474",
      "poi_longitude": "-97.5201329",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-708-6937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-914d-73e9-8ec8-29ebc9c345ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-914d-73e9-8ec8-29ebc9c345ab",
        "storage_key": "property/6767906449167180/01a14134-914d-73e9-8ec8-29ebc9c345ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq_h7xU0XsocRP2QWzKIJ_u8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_e8537b41-b26d-4744-bde4-2fd883c3c1b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "The Jones Assembly",
      "poi_type": "Restaurants",
      "poi_address": "901 W Sheridan Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "Live music, plus regional American fare & craft cocktails, in a spacious, industrial-chic venue.",
      "poi_long_description": "Live music, plus regional American fare & craft cocktails, in a spacious, industrial-chic venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6601-71af-8bd3-70382cfb5c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6601-71af-8bd3-70382cfb5c4e",
        "storage_key": "property/6767906449167180/01a14134-6601-71af-8bd3-70382cfb5c4e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thejonesassembly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206338142797659122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-jones-assembly",
      "poi_latitude": "35.4666469",
      "poi_longitude": "-97.5273857",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-212-2378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a98-70d9-95fd-5fa8b36bd38e",
        "storage_key": "property/6767906449167180/019d021e-8a98-70d9-95fd-5fa8b36bd38e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwcSZY9QQsocR8nsRmXIP3QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4e9a6162-4b11-444a-9f30-3664a561cc1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "OU Health ER & Urgent Care SOKC",
      "poi_type": "Health and Wellness",
      "poi_address": "3025 SW 104th St, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-614d-7520-bdd4-a2c77651c788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-614d-7520-bdd4-a2c77651c788",
        "storage_key": "property/6767906449167180/01a14134-614d-7520-bdd4-a2c77651c788.webp",
        "width": 734,
        "height": 413
      },
      "poi_business_url": "https://www.ouhealth.com/find-a-location/ou-health-er-urgent-care-sokc/?utm_source=loclistings&utm_medium=organic&y_source=1_MjAxMDM4MjI0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16681390442409023041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ou-health-er--urgent-care-sokc",
      "poi_latitude": "35.36358440000001",
      "poi_longitude": "-97.568098",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-300-7740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx4pDSkTsocRQdZivzk0gOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_466fbb76-864c-4916-803b-9d670b2adf6c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "First Med Urgent Care - South Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "7807 S Walker Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6416-76d4-8199-3bfdf14c7c84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6416-76d4-8199-3bfdf14c7c84",
        "storage_key": "property/6767906449167180/01a14134-6416-76d4-8199-3bfdf14c7c84.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.firstmed.health/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10536162271088446916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-med-urgent-care---south-oklahoma-city",
      "poi_latitude": "35.388726",
      "poi_longitude": "-97.5217521",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-759-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SoSEHcUsocRxI0ZOMP3N5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_dcde0b2f-0af5-46a1-b992-969d366f17f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Care+ Pediatrics Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "8500 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6607-72c9-8ef6-cc20d74cb305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6607-72c9-8ef6-cc20d74cb305",
        "storage_key": "property/6767906449167180/01a14134-6607-72c9-8ef6-cc20d74cb305.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.carepluspediatrics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13871697858103144461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "care-pediatrics-urgent-care",
      "poi_latitude": "35.3819307",
      "poi_longitude": "-97.5294982",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-493-9129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTgx3rgTsocRDfDI37QrgsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3cc71ac9-cea5-46db-a8c4-1989bd10d9a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Community Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3100 SW 89th St, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6bdc-76a5-a2cd-ffd37934d768.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6bdc-76a5-a2cd-ffd37934d768",
        "storage_key": "property/6767906449167180/01a14134-6bdc-76a5-a2cd-ffd37934d768.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.communityhospitalokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9440951255988147333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "community-hospital",
      "poi_latitude": "35.375805899999996",
      "poi_longitude": "-97.570525",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-602-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVPr9lQSsocRhZTzoiX_BIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_62f9b4be-edbf-423d-9762-2d2b5bc37ce0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City - South",
      "poi_type": "Health and Wellness",
      "poi_address": "5200 E Interstate 240 Service Rd, Oklahoma City, OK 73135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6745-7028-8349-2fd130e6bf62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6745-7028-8349-2fd130e6bf62",
        "storage_key": "property/6767906449167180/01a14134-6745-7028-8349-2fd130e6bf62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city-south?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTYyMzc5ODQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8024362121839285447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city---south",
      "poi_latitude": "35.39042370000001",
      "poi_longitude": "-97.4281147",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-416-9701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTIbz0I_socRx5RUvdVCXG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7b63b4d8-ca19-4289-8e5f-0b9cf6622704",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3301 SW 104th St, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-684a-7465-87ca-cb0fd0b5efbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-684a-7465-87ca-cb0fd0b5efbd",
        "storage_key": "property/6767906449167180/01a14134-684a-7465-87ca-cb0fd0b5efbd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/7326-oklahoma-city-ok/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3944773237142521091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.365392199999995",
      "poi_longitude": "-97.5774104",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-300-6572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-914c-764a-9524-b6a0010be280.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-914c-764a-9524-b6a0010be280",
        "storage_key": "property/6767906449167180/01a14134-914c-764a-9524-b6a0010be280.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_PME_sSsocRAwVZ31umvjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d9190faf-bf91-4603-89b9-978abbb057d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Scissortail CrossFit",
      "poi_type": "Health and Wellness",
      "poi_address": "6807 S Western Ave Suite 007, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Fitness center in the Southwestern Office Center offering CrossFit and Olympic lifting workouts, plus a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6cbc-7531-933b-764852462477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6cbc-7531-933b-764852462477",
        "storage_key": "property/6767906449167180/01a14134-6cbc-7531-933b-764852462477.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5350712538011487234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scissortail-crossfit",
      "poi_latitude": "35.3984962",
      "poi_longitude": "-97.5315066",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-535-7453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UiEQ9cTsocRAkxnO7SMQUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_806f76de-83ae-45c5-a262-68ff7b0748b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Brookwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9600 S Shartel Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6c9f-702d-ac7a-7456d766e533.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6c9f-702d-ac7a-7456d766e533",
        "storage_key": "property/6767906449167180/01a14134-6c9f-702d-ac7a-7456d766e533.webp",
        "width": 1241,
        "height": 1110
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15071690471378684053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookwood-park",
      "poi_latitude": "35.372173",
      "poi_longitude": "-97.5240047",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1dd1-71fd-94a4-bf8687dacc2a",
        "storage_key": "property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3PdwQ4VsocRlYgqZ6FmKdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4921c666-626e-48c8-9c75-acff6e9460d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Lightning Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8198 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Open fields and a creek for soccer, plus clean restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-6d0d-7211-b094-40b139ac9969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-6d0d-7211-b094-40b139ac9969",
        "storage_key": "property/6767906449167180/01a14134-6d0d-7211-b094-40b139ac9969.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/rededication-of-lightening-creek-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11062888227037365421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lightning-creek-park",
      "poi_latitude": "35.3862076",
      "poi_longitude": "-97.5276983",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1dd1-71fd-94a4-bf8687dacc2a",
        "storage_key": "property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-5ugg4gTsocRrcRpkjpGh5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e7c8b24e-e134-4b49-91e1-32aa1d4d1be8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Lippert Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5500 S Shartel Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-7318-7438-94b4-6a957204ce36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-7318-7438-94b4-6a957204ce36",
        "storage_key": "property/6767906449167180/01a14134-7318-7438-94b4-6a957204ce36.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15250954611216533035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lippert-park",
      "poi_latitude": "35.4100531",
      "poi_longitude": "-97.5263249",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1dd1-71fd-94a4-bf8687dacc2a",
        "storage_key": "property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fsbbAATsocRK8Yqd2pGptM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9c1005dd-a2f5-4f34-ae82-e66fe5a80ab9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Southern Oaks Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6728 S Walker Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-7427-7231-b5c4-bcd80f255428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-7427-7231-b5c4-bcd80f255428",
        "storage_key": "property/6767906449167180/01a14134-7427-7231-b5c4-bcd80f255428.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8608200733344459906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-oaks-park",
      "poi_latitude": "35.397521499999996",
      "poi_longitude": "-97.519193",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1dd1-71fd-94a4-bf8687dacc2a",
        "storage_key": "property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxe2sT5IVsocRguxAcvV4dnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ce707bca-7cb5-459b-9394-7f80184d49be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Taylor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1101-1149 SW 70th St, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Recreational area boasting a playground and splash pad, plus walking trails and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-73bf-7175-a883-6045e9770052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-73bf-7175-a883-6045e9770052",
        "storage_key": "property/6767906449167180/01a14134-73bf-7175-a883-6045e9770052.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/193/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11528514088938904838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taylor-park",
      "poi_latitude": "35.4271987",
      "poi_longitude": "-97.7195109",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 17 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1dd1-71fd-94a4-bf8687dacc2a",
        "storage_key": "property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1daAq_ITsocRBh1Ks3uC_Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_f75bd77c-760a-4b19-a1bb-f79f1f32e1d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "E.M. Sellers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8301 S Villa Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Community park featuring a popular splash pad and a walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-73b1-74ef-9827-09002998fea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-73b1-74ef-9827-09002998fea0",
        "storage_key": "property/6767906449167180/01a14134-73b1-74ef-9827-09002998fea0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13524912576132087363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "em-sellers-park",
      "poi_latitude": "35.3829212",
      "poi_longitude": "-97.5583258",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-297-1445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1dd1-71fd-94a4-bf8687dacc2a",
        "storage_key": "property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2Gu668TsocRQ_6QdlQksrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_60b8b5fd-211d-40b2-89a8-90959c247a0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "South Lakes Soccer Club",
      "poi_type": "Health and Wellness",
      "poi_address": "12310 S Meridian Ave, Oklahoma City, OK 73173, USA",
      "poi_short_description": "Well-maintained soccer complex offering youth sports facilities and recreational park amenities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-76c4-7068-b700-c2c92ff74d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-76c4-7068-b700-c2c92ff74d88",
        "storage_key": "property/6767906449167180/01a14134-76c4-7068-b700-c2c92ff74d88.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.southlakessoccer.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11484715820514452070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-lakes-soccer-club",
      "poi_latitude": "35.3453357",
      "poi_longitude": "-97.598169",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUclraISsocRZqISrDDoYZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_94562a94-7599-432d-960c-707dd08269dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "South Lakes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4210 SW 119th St, Oklahoma City, OK 73173, USA",
      "poi_short_description": "A 158-acre park with a wide range of amenities from soccer fields to a skate park & fishing ponds.",
      "poi_long_description": "A 158-acre park with a wide range of amenities from soccer fields to a skate park & fishing ponds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-7b8c-733d-b056-a430b31c6ea3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-7b8c-733d-b056-a430b31c6ea3",
        "storage_key": "property/6767906449167180/01a14134-7b8c-733d-b056-a430b31c6ea3.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14666010017009772083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-lakes-park",
      "poi_latitude": "35.3449217",
      "poi_longitude": "-97.5956023",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-1dd1-71fd-94a4-bf8687dacc2a",
        "storage_key": "property/6767906449167180/019d021f-1dd1-71fd-94a4-bf8687dacc2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6ki8rwSsocRMyYwGGgiiMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_42b39d61-f787-42f9-b071-32701dc085c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Brookwood Village",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 S Shartel Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-78b8-71e9-b1e1-2472f8cec469.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-78b8-71e9-b1e1-2472f8cec469",
        "storage_key": "property/6767906449167180/01a14134-78b8-71e9-b1e1-2472f8cec469.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://oklahoma.weidner.com/apartments/ok/oklahoma-city/brookwood-village/index.aspx?rcstdid=Mg%3D%3D-YRjTEizZPgM%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17769364603760788337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookwood-village",
      "poi_latitude": "35.3736999",
      "poi_longitude": "-97.525236",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-759-5052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJte6VEIAUsocRccOPA_Z2mfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "custom_5f5f84e9-df10-4339-8256-13699f2d7d06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "S Western Ave @ SW 89 St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1902967805537864400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s-western-ave--sw-89-st",
      "poi_latitude": "35.3761418",
      "poi_longitude": "-97.530265",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-914d-73e9-8ec8-274803fe6895.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-914d-73e9-8ec8-274803fe6895",
        "storage_key": "property/6767906449167180/01a14134-914d-73e9-8ec8-274803fe6895.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9frqJ4ITsocR0MoWBCOzaBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_b45f4045-5dcc-4f21-a1e3-709e364bd124",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Arvest Bank",
      "poi_type": "Transportation & Transit",
      "poi_address": "9350 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Community-oriented bank providing personal financial services and account management.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-7fbe-705a-8a2c-31f213250da6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-7fbe-705a-8a2c-31f213250da6",
        "storage_key": "property/6767906449167180/01a14134-7fbe-705a-8a2c-31f213250da6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.arvest.com/locations/us/ok/9350-south-western-avenue-bank",
      "poi_directions_map_url": "https://maps.google.com/?cid=15519529347907816912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arvest-bank",
      "poi_latitude": "35.374054799999996",
      "poi_longitude": "-97.5291256",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-677-8711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-9199-7434-b108-2955f0c50af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-9199-7434-b108-2955f0c50af1",
        "storage_key": "property/6767906449167180/01a14134-9199-7434-b108-2955f0c50af1.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJJx2zRn8TsocR0I1LR7dxYNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_40d0c384-162c-4902-be7c-468e95e06912",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "EMBARK Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "420 NW 5th St, Oklahoma City, OK 73102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-7ce1-735e-8ad5-cc8a998e49a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-7ce1-735e-8ad5-cc8a998e49a0",
        "storage_key": "property/6767906449167180/01a14134-7ce1-735e-8ad5-cc8a998e49a0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.embarkok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14426165324210204102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "embark-transit-center",
      "poi_latitude": "35.4725122",
      "poi_longitude": "-97.5198169",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-235-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUw7Jwy0XsocRxm2b5O0INMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_a5259b46-9ba0-421e-9562-1015f288375a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Oklahoma City",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 S E K Gaylord Blvd, Oklahoma City, OK 73102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-7e39-7443-bdfc-8fb05fd235fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-7e39-7443-bdfc-8fb05fd235fb",
        "storage_key": "property/6767906449167180/01a14134-7e39-7443-bdfc-8fb05fd235fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=18415520422701629828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-city",
      "poi_latitude": "35.465489999999996",
      "poi_longitude": "-97.51275",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-914d-73e9-8ec8-274803fe6895.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-914d-73e9-8ec8-274803fe6895",
        "storage_key": "property/6767906449167180/01a14134-914d-73e9-8ec8-274803fe6895.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VqBFCYXsocRhAEVPUESkf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_stop"
    },
    {
      "id": "custom_85912c62-036f-425a-bc42-4504a7a3fde3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1948 E Reno Ave, Oklahoma City, OK 73117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-7dde-7219-8b1f-deaea8e1ce16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-7dde-7219-8b1f-deaea8e1ce16",
        "storage_key": "property/6767906449167180/01a14134-7dde-7219-8b1f-deaea8e1ce16.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/oklahoma-city-ok/oklahoma-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16344711894024616223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "35.463749199999995",
      "poi_longitude": "-97.4773124",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5azw7FQWsocRH3lwn94U1OI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_e92b575a-1038-4939-b5d7-cfb53ef52c39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Will Rogers International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7100 Terminal Dr, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Oklahoma City-area airport featuring art & an outdoor garden with a bronze statue of its namesake.",
      "poi_long_description": "Oklahoma City-area airport featuring art & an outdoor garden with a bronze statue of its namesake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14131-f2ab-73c3-884d-9e4723b7f4c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-f2ab-73c3-884d-9e4723b7f4c9",
        "storage_key": "property/6767906449167180/01a14131-f2ab-73c3-884d-9e4723b7f4c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flyokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14888269631623114364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "will-rogers-international-airport",
      "poi_latitude": "35.3888421",
      "poi_longitude": "-97.6001183",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-316-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a6-7263-892e-f3fc835db259.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a6-7263-892e-f3fc835db259",
        "storage_key": "property/6767906449167180/019d021e-96a6-7263-892e-f3fc835db259.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X8qew0SsocRfK4hOVnCnc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b8d62eda-d888-431d-9ea2-3e32d7bbe0a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Oklahoma Center for Orthopedic & Multi-Specialty Surgery",
      "poi_type": "Health and Wellness",
      "poi_address": "8100 S Walker Ave Bldg C, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-8109-764b-858f-207647c352b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-8109-764b-858f-207647c352b0",
        "storage_key": "property/6767906449167180/01a14134-8109-764b-858f-207647c352b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ocomhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15940073535775917280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-center-for-orthopedic--multi-specialty-surgery",
      "poi_latitude": "35.3849944",
      "poi_longitude": "-97.5198849",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-602-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2y583kUsocR4ESHOW2ENt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f1a5d1db-3730-4058-ae61-40b13a0b11b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Surgical Hospital Of Oklahoma",
      "poi_type": "Health and Wellness",
      "poi_address": "100 SE 59th St, Oklahoma City, OK 73129, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-840b-744d-915d-2aab58f23b51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-840b-744d-915d-2aab58f23b51",
        "storage_key": "property/6767906449167180/01a14134-840b-744d-915d-2aab58f23b51.webp",
        "width": 1280,
        "height": 777
      },
      "poi_business_url": "https://surgicalhospitalok.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17451737681924062387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "surgical-hospital-of-oklahoma",
      "poi_latitude": "35.4058862",
      "poi_longitude": "-97.5093437",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-634-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTdYrHhEUsocRs_xhXPUGMfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_41ea68fe-0600-47bf-b252-ddb42bdab0b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "INTEGRIS Health Southwest Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 S Western Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-592e-74f7-ae0e-25d5de3c705a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-592e-74f7-ae0e-25d5de3c705a",
        "storage_key": "property/6767906449167180/019d021e-592e-74f7-ae0e-25d5de3c705a.webp",
        "width": 683,
        "height": 384
      },
      "poi_business_url": "https://integrishealth.org/locations/hospital/integris-health-southwest-medical-center?utm_source=gbp&utm_medium=organic&utm_campaign=location-page-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12771302873382817443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "integris-health-southwest-medical-center",
      "poi_latitude": "35.421264799999996",
      "poi_longitude": "-97.5330065",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-636-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28Mb51YRsocRo47oTkzIPLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_734db2b9-cadb-48f3-8cbd-f3fe49b21912",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-85bd-7714-974b-cd2fe39fd248.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-85bd-7714-974b-cd2fe39fd248",
        "storage_key": "property/6767906449167180/01a14134-85bd-7714-974b-cd2fe39fd248.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://integrishealth.org/locations/hospital/integris-health-baptist-medical-center?utm_source=gbp&utm_medium=organic&utm_campaign=location-page-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_0422335d-0fe8-4737-aff6-941a198086f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "OU Health Physicians Building - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "825 NE 10th St, Oklahoma City, OK 73104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-8225-74e8-8278-a6802efa3987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-8225-74e8-8278-a6802efa3987",
        "storage_key": "property/6767906449167180/01a14134-8225-74e8-8278-a6802efa3987.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ouhealth.com/find-a-location/ou-health-physicians/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1766121348450926722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ou-health-physicians-building---oklahoma-city",
      "poi_latitude": "35.4786834",
      "poi_longitude": "-97.4978779",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-271-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWjthUYYsocRgsCmVAKGghg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c36cb13e-b246-4793-a378-66c134dd5af2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "OU Health University of Oklahoma Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "700 NE 13th St, Oklahoma City, OK 73104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-7b4f-760c-924a-2e3dd42a2edf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-7b4f-760c-924a-2e3dd42a2edf",
        "storage_key": "property/6767906449167180/019d021e-7b4f-760c-924a-2e3dd42a2edf.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ouhealth.com/find-a-location/ou-health-university-of-oklahoma-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13319687687583781516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ou-health-university-of-oklahoma-medical-center",
      "poi_latitude": "35.4802675",
      "poi_longitude": "-97.4967462",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-271-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ePGKSAXsocRjFKTkWEJ2bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_663f6821-30e4-4300-a6e8-aa2389888d35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Oklahoma Children's OU Health",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 Children's Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-8559-76e9-b23e-15ef3ac7fde7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-8559-76e9-b23e-15ef3ac7fde7",
        "storage_key": "property/6767906449167180/01a14134-8559-76e9-b23e-15ef3ac7fde7.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.oklahomachildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6325816880667187348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-childrens-ou-health",
      "poi_latitude": "35.4811967",
      "poi_longitude": "-97.4976455",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 572-244-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-96a4-709b-9c01-63d88cd7f8d2",
        "storage_key": "property/6767906449167180/019d021e-96a4-709b-9c01-63d88cd7f8d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx3fD_BMXsocRlFhW9u_QyVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f553eb92-8451-440a-a689-63ed74e11531",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Tinker Air Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Oklahoma City, OK 73145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-872e-779f-a2ae-9c9449c91d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-872e-779f-a2ae-9c9449c91d88",
        "storage_key": "property/6767906449167180/01a14134-872e-779f-a2ae-9c9449c91d88.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16141469542995961359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tinker-air-force-base",
      "poi_latitude": "35.4288768",
      "poi_longitude": "-97.4207804",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-9bf6-700d-97fc-a82e822e0168.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-9bf6-700d-97fc-a82e822e0168",
        "storage_key": "property/6767906449167180/019d021e-9bf6-700d-97fc-a82e822e0168.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJfsPM_89socRD6YPNwcFAuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_2105e86b-df75-4164-9788-4a198a87f7f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "Devon Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 W Sheridan Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8048-7313-8a05-30a1391a8fa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-8048-7313-8a05-30a1391a8fa0",
        "storage_key": "property/6767906449167180/019d021e-8048-7313-8a05-30a1391a8fa0.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.devonenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=388556926193357933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "devon-energy",
      "poi_latitude": "35.467408299999995",
      "poi_longitude": "-97.518044",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-228-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-8a91-704b-ad34-03094f2bb9a5",
        "storage_key": "property/6767906449167180/019d021e-8a91-704b-ad34-03094f2bb9a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rqFSkXsocRbdTFOHduZAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b05bd515-3a03-4046-82ea-279e460e448a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "custom",
      "poi_name": "MidFirst Bank Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 NW Grand Blvd, Oklahoma City, OK 73118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-86d8-724f-ae27-72e19958a966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14134-86d8-724f-ae27-72e19958a966",
        "storage_key": "property/6767906449167180/01a14134-86d8-724f-ae27-72e19958a966.webp",
        "width": 256,
        "height": 256
      },
      "poi_business_url": "https://www.midfirst.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7126719422396296476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midfirst-bank-corporate",
      "poi_latitude": "35.5290882",
      "poi_longitude": "-97.5210336",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/01a14134-9199-7434-b108-2955f0c50af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14134-9199-7434-b108-2955f0c50af1",
        "storage_key": "property/6767906449167180/01a14134-9199-7434-b108-2955f0c50af1.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJB6nqPosZsocRHO3OQY4x52I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b90af01ca7e424eb1605264c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_eb31efba1a7df9ccad1e5dda",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a9765c48fc08a636f48579aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "day": "WED",
      "open_time": "10:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_978f30cdcf7e92c7a00cf47e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_10ad5b0962dc576e36b7843f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8bc9f82e0e6637e01b1a6572",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a0be2057e3ab8b6fcdda8f32",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "rating": "5",
      "name": "Natalia Remigio",
      "text": "Dulce is an exceptional leasing agent who goes above and beyond for her tenants. From the initial apartment viewing to addressing any concerns throughout my tenancy, she has consistently demonstrated professionalism, responsiveness, and a genuine commitment to ensuring resident satisfaction.What sets Dulce apart is her proactive approach to property management. She is quick to handle maintenance requests, resolve issues, and communicate important information, making the entire rental experience smooth and stress-free. Her friendly demeanor and willingness to assist with any questions or needs have made me feel valued and well-cared for as a resident.\nOverall, I highly recommend Dulce to anyone seeking a top-notch leasing agent. Her dedication, expertise, and exceptional customer service make her an invaluable asset to any property management team. Thanks to Dulce, my experience with this apartment has been outstanding.",
      "date": "2025-10-11",
      "title": "false"
    },
    {
      "id": "ec_69c4f2bc8ef7ccd0f51460d6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "rating": "5",
      "name": "Tyrone SR Hill",
      "text": "This place is amazing. I know you hear this all the time about places, but my experience with Brittany at Brookwood was so professional, so easy going and the way they conduct business takes away any stress of getting into an apartment. I recommend anyone who is looking for a new place for you or your adult child, i’d encourage you to check out Brookwood Village. Go ask for Brittany and tell her Tyrone sent you.",
      "date": "2025-12-14",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_3730bb6a9c57f47efaf933a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "2465269",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 30,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_ea0430c18388cc8cd811f5b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "yardi",
      "external_id": "2465268",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 30,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-daaa-7694-a5c6-c19759afba75",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Brookwood Village Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "apartments-with-pool-in-oklahoma-city-brookwood-village",
      "search_query": "apartments with pool in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Oklahoma City",
      "h2_subtitle": "Experience the best of apartment living with a pool in South OKC. Brookwood Village offers an inviting oasis perfect for relaxation.",
      "page_copy": "Discover Brookwood Village, where our apartments offer an exceptional lifestyle in Oklahoma City. Nestled in South OKC, our community features a sparkling pool ideal for unwinding after a long day. Here, you can enjoy central heat and air conditioning, a fitness center, and the peace of mind that comes with on-site maintenance.\n\nOur community at Brookwood Village also benefits from night patrol, ensuring safety and security. Select first-floor homes boast elegant plank style flooring, adding a touch of sophistication. If you're searching for apartments with a pool in Oklahoma City, Brookwood Village is the perfect choice for a comfortable and convenient lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Oklahoma City",
      "seo_description": "Discover Brookwood Village apartments with a pool in Oklahoma City. Enjoy a community in South OKC with great amenities like a fitness center and night patrol.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "brookwood-village-dog-park-apartments",
      "search_query": "Brookwood Village dog park apartments",
      "category": "Amenity",
      "h1_title": "Brookwood Village Dog Park Apartments",
      "h2_subtitle": "Discover pet-friendly living at Brookwood Village. Enjoy the convenience of dog park apartments in Oklahoma City's vibrant South OKC community.",
      "page_copy": "Welcome to Brookwood Village, where pets are part of the family. Our dog park apartments are perfect for pet owners seeking comfort and convenience in Oklahoma City. Set in the lively South OKC neighborhood, Brookwood Village ensures your furry friends feel right at home, with spaces designed just for them.\n\nOur community comes equipped with amenities that cater to pet lovers and beyond. From central heat and air conditioning to a state-of-the-art fitness center, there's something for everyone. Maintenance on-site ensures everything stays in tip-top shape, while our plank style flooring in select first-floor homes adds a touch of elegance. Choose Brookwood Village for the ultimate pet-friendly apartment experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Brookwood Village Dog Park Apartments",
      "seo_description": "Discover Brookwood Village dog park apartments in South OKC. Enjoy pet-friendly living with amenities like a fitness center and on-site maintenance.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "modern-fitness-center-apartments-okc-brookwood-village",
      "search_query": "modern fitness center apartments OKC",
      "category": "Amenity",
      "h1_title": "Modern Fitness Center Apartments OKC",
      "h2_subtitle": "Stay fit and active at Brookwood Village, where modern fitness center apartments redefine living in Oklahoma City’s South OKC.",
      "page_copy": "Brookwood Village offers a unique blend of comfort and active living with our modern fitness center apartments in OKC. Nestled in the bustling South Oklahoma City, our community is designed for those who value health and wellness.\n\nBeyond the fitness center, residents enjoy amenities like air conditioning, on-site maintenance, and the safety of night patrols. Select first-floor apartments feature beautiful plank style flooring, adding a refined touch to your living space. Choose Brookwood Village for a lifestyle that combines convenience with modern fitness opportunities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Fitness Center Apartments OKC",
      "seo_description": "Explore Brookwood Village in South OKC. Our modern fitness center apartments offer a vibrant living experience with amenities like night patrol and air conditioning.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "spacious-pet-friendly-apartments-cleveland-county-brookwood-village",
      "search_query": "spacious pet-friendly apartments Cleveland County",
      "category": "Amenity",
      "h1_title": "Spacious Pet-Friendly Apartments Cleveland County",
      "h2_subtitle": "Discover spacious pet-friendly apartments at Brookwood Village, located in the heart of Cleveland County’s South Oklahoma City neighborhood.",
      "page_copy": "At Brookwood Village, we offer spacious pet-friendly apartments that are perfect for you and your furry companions. Located in Cleveland County, within the lively South Oklahoma City area, our community combines generous living spaces with pet-friendly amenities.\n\nResidents enjoy central heat and air conditioning, a modern fitness center, and the convenience of maintenance on site. Our community is also equipped with a night patrol, enhancing security and peace of mind. Select first-floor homes feature stylish plank flooring, adding a touch of sophistication. Choose Brookwood Village for spacious living with your pets in a vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Pet-Friendly Apartments Cleveland County",
      "seo_description": "Find spacious pet-friendly apartments at Brookwood Village in Cleveland County. Enjoy amenities like a fitness center and on-site maintenance in South OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-with-air-conditioning-brookwood-village",
      "search_query": "Oklahoma City apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Oklahoma City Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool at Brookwood Village in Oklahoma City. Explore our apartments with modern air conditioning and a welcoming community.",
      "page_copy": "Brookwood Village in South Oklahoma City offers comfortable and climate-controlled living spaces, perfect for any season. Our Oklahoma City apartments come equipped with modern air conditioning, ensuring you stay cool and comfortable year-round.\n\nBesides climate comfort, residents benefit from a top-notch fitness center, on-site maintenance, and a vigilant night patrol for added safety. Select apartments feature plank style flooring, offering a stylish touch to your home. Experience comfortable living with all the modern conveniences at Brookwood Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Oklahoma City Apartments with Air Conditioning",
      "seo_description": "Discover air-conditioned apartments at Brookwood Village in South OKC. Enjoy amenities like a fitness center and on-site maintenance for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-oklahoma-city-brookwood-village",
      "search_query": "one bedroom apartments in South Oklahoma City",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South OKC",
      "h2_subtitle": "Find comfortable one bedroom apartments in South Oklahoma City at Brookwood Village. Enjoy a blend of style and convenience in our vibrant community.",
      "page_copy": "Brookwood Village is your destination for one bedroom apartments in South Oklahoma City. Our thoughtfully designed homes provide the perfect space for individuals or couples seeking comfort and convenience in a lively neighborhood.\n\nEach one bedroom apartment is equipped with central air conditioning and heating, ensuring a comfortable living environment regardless of the season. Alongside air-conditioned comfort, residents enjoy access to our full-service fitness center, on-site maintenance, and vigilant night patrol. Some units even offer beautiful plank style flooring for an added touch of elegance. Make Brookwood Village your new home in South OKC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South OKC",
      "seo_description": "Explore one bedroom apartments at Brookwood Village in South OKC. Enjoy central air conditioning, a fitness center, and a lively community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-cleveland-county-ok-brookwood-village",
      "search_query": "two bedroom apartments in Cleveland County OK",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Cleveland County, OK",
      "h2_subtitle": "Discover spacious two bedroom apartments at Brookwood Village, ideally located in Cleveland County, OK with modern amenities and a welcoming community.",
      "page_copy": "Welcome to Brookwood Village, where our two bedroom apartments in Cleveland County, OK offer the perfect blend of comfort and space for you and your family. Nestled in the heart of South Oklahoma City, these homes are designed to meet modern living standards with ample room and stylish finishes.\n\nEach apartment comes with central heat and air conditioning to ensure year-round comfort. Residents can take advantage of community amenities like our state-of-the-art fitness center, reliable on-site maintenance, and night patrol services. Select units offer stylish plank flooring, adding a touch of elegance throughout the spacious interiors. Choose Brookwood Village for a vibrant and comfortable living experience in Cleveland County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Cleveland County, OK",
      "seo_description": "Explore two bedroom apartments at Brookwood Village in Cleveland County, OK. Enjoy amenities like air conditioning, a fitness center, and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167180",
      "source": "generator",
      "page_item_url": "three-bedroom-apartment-near-73139-brookwood-village",
      "search_query": "three bedroom apartment near 73139",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartment Near 73139",
      "h2_subtitle": "Discover spacious three bedroom apartments near the 73139 area at Brookwood Village, offering modern amenities and a community atmosphere.",
      "page_copy": "At Brookwood Village, our three bedroom apartments near the 73139 area provide the ideal setting for families or those needing extra space. Situated in the vibrant South Oklahoma City neighborhood, these generously-sized apartments balance comfort and style, tailored to fit your lifestyle.\n\nEach apartment features central heat and air conditioning, ensuring a comfortable living environment throughout the year. Community benefits include a well-equipped fitness center, reliable on-site maintenance, and vigilant night patrol services. With additional features like plank style flooring available in select units, Brookwood Village offers a harmonious blend of convenience and modern living near the 73139 ZIP code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartment Near 73139",
      "seo_description": "Find three bedroom apartments at Brookwood Village, near 73139. Enjoy spacious living with modern amenities and a vibrant South OKC community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309460044"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057594916"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WR39CRK4"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "c3204b61-6cd6-4a48-a19f-401ac638c485"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/cdf1ef32-1a77-4dc3-b8bd-ec348f31567d/app.js?property=cdf1ef32-1a77-4dc3-b8bd-ec348f31567d&propertyName=Brookwood+Village&channelUuid=c248ec17-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47564050535"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjN1MlZqbi9UeDc0akJEOEFWSEU0aGc9PSIsInZhbHVlIjoiZ29MUjVXTDVkZXhWSk9CbU40N0c2UT09IiwibWFjIjoiOGMzODE0N2QxZTgzOGRhY2RlZDg0NjdmNzg4ZmQ0YTVlNjAwMTVkZDFjNzc1MTU3MzMzYjYxNjUyZTU1M2VlZSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309460044",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057594916",
  "custom_google_gtm_id": "GTM-WR39CRK4",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "c3204b61-6cd6-4a48-a19f-401ac638c485",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/cdf1ef32-1a77-4dc3-b8bd-ec348f31567d/app.js?property=cdf1ef32-1a77-4dc3-b8bd-ec348f31567d&propertyName=Brookwood+Village&channelUuid=c248ec17-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47564050535",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjN1MlZqbi9UeDc0akJEOEFWSEU0aGc9PSIsInZhbHVlIjoiZ29MUjVXTDVkZXhWSk9CbU40N0c2UT09IiwibWFjIjoiOGMzODE0N2QxZTgzOGRhY2RlZDg0NjdmNzg4ZmQ0YTVlNjAwMTVkZDFjNzc1MTU3MzMzYjYxNjUyZTU1M2VlZSJ9",
  "custom_audioeye_site_id": "ce6e7882-efa5-41b6-950c-bb230fa02b5b",
  "custom_audioeye_site_hash": "407b621790aff574104ccb844b4017fe"
};

export const generatedAt = '2026-11-04T23:48:03.017Z';
